const net = `# v2.2.0
# ./Infomap  --silent --two-level --directed --num-trials 100
*Vertices
0 "Myriel"
1 "Napoleon"
2 "MlleBaptistine"
3 "MmeMagloire"
4 "CountessDeLo"
5 "Geborand"
6 "Champtercier"
7 "Cravatte"
8 "Count"
9 "OldMan"
10 "Labarre"
11 "Valjean"
12 "Marguerite"
13 "MmeDeR"
14 "Isabeau"
15 "Gervais"
16 "Tholomyes"
17 "Listolier"
18 "Fameuil"
19 "Blacheville"
20 "Favourite"
21 "Dahlia"
22 "Zephine"
23 "Fantine"
24 "MmeThenardier"
25 "Thenardier"
26 "Cosette"
27 "Javert"
28 "Fauchelevent"
29 "Bamatabois"
30 "Perpetue"
31 "Simplice"
32 "Scaufflaire"
33 "Woman1"
34 "Judge"
35 "Champmathieu"
36 "Brevet"
37 "Chenildieu"
38 "Cochepaille"
39 "Pontmercy"
40 "Boulatruelle"
41 "Eponine"
42 "Anzelma"
43 "Woman2"
44 "MotherInnocent"
45 "Gribier"
46 "Jondrette"
47 "MmeBurgon"
48 "Gavroche"
49 "Gillenormand"
50 "Magnon"
51 "MlleGillenormand"
52 "MmePontmercy"
53 "MlleVaubois"
54 "LtGillenormand"
55 "Marius"
56 "BaronessT"
57 "Mabeuf"
58 "Enjolras"
59 "Combeferre"
60 "Prouvaire"
61 "Feuilly"
62 "Courfeyrac"
63 "Bahorel"
64 "Bossuet"
65 "Joly"
66 "Grantaire"
67 "MotherPlutarch"
68 "Gueulemer"
69 "Babet"
70 "Claquesous"
71 "Montparnasse"
72 "Toussaint"
73 "Child1"
74 "Child2"
75 "Brujon"
76 "MmeHucheloup"
*States
# stateId physicalId
1 1
2 2
3 3
4 4
5 5
6 6
7 7
8 8
9 9
11 11
1024 0
2048 0
2051 3
2059 11
3072 0
3074 2
3083 11
4096 0
5120 0
6144 0
7168 0
8192 0
9216 0
10251 11
11264 0
11266 2
11267 3
11274 10
11276 12
11277 13
11278 14
11279 15
11287 23
11288 24
11289 25
11290 26
11291 27
11292 28
11293 29
11295 31
11296 32
11297 33
11298 34
11299 35
11300 36
11301 37
11302 38
11307 43
11308 44
11312 48
11313 49
11315 51
11319 55
11322 58
11328 64
11332 68
11333 69
11334 70
11335 71
11336 72
12299 11
12311 23
13323 11
14347 11
15371 11
16401 17
16402 18
16403 19
16404 20
16405 21
16406 22
16407 23
16410 26
16439 55
17424 16
17426 18
17427 19
17428 20
17429 21
17430 22
17431 23
18448 16
18449 17
18451 19
18452 20
18453 21
18454 22
18455 23
19472 16
19473 17
19474 18
19476 20
19477 21
19478 22
19479 23
20496 16
20497 17
20498 18
20499 19
20501 21
20502 22
20503 23
21520 16
21521 17
21522 18
21523 19
21524 20
21526 22
21527 23
22544 16
22545 17
22546 18
22547 19
22548 20
22549 21
22551 23
23563 11
23564 12
23568 16
23569 17
23570 18
23571 19
23572 20
23573 21
23574 22
23576 24
23577 25
23579 27
23581 29
23582 30
23583 31
24587 11
24599 23
24601 25
24602 26
24603 27
24617 41
24618 42
24626 50
24644 68
24645 69
24646 70
25611 11
25623 23
25624 24
25626 26
25627 27
25639 39
25640 40
25641 41
25642 42
25648 48
25655 55
25668 68
25669 69
25670 70
25671 71
25675 75
26635 11
26640 16
26648 24
26649 25
26651 27
26667 43
26673 49
26675 51
26678 54
26679 55
26696 72
27659 11
27671 23
27672 24
27673 25
27674 26
27676 28
27677 29
27679 31
27681 33
27691 43
27696 48
27706 58
27716 68
27717 69
27718 70
27719 71
27720 72
28683 11
28699 27
28716 44
28717 45
29707 11
29719 23
29723 27
29730 34
29731 35
29732 36
29733 37
29734 38
30743 23
30751 31
31755 11
31767 23
31771 27
31774 30
32779 11
33803 11
33819 27
34827 11
34845 29
34851 35
34852 36
34853 37
34854 38
35851 11
35869 29
35874 34
35876 36
35877 37
35878 38
36875 11
36893 29
36898 34
36899 35
36901 37
36902 38
37899 11
37917 29
37922 34
37923 35
37924 36
37926 38
38923 11
38941 29
38946 34
38947 35
38948 36
38949 37
39961 25
39988 52
39991 55
40985 25
42008 24
42009 25
42026 42
42039 55
42041 57
42046 62
42052 68
42053 69
42054 70
42055 71
42059 75
43032 24
43033 25
43049 41
44043 11
44058 26
44059 27
45067 11
45084 28
46108 28
47151 47
48174 46
48176 48
49163 11
49177 25
49179 27
49199 47
49207 55
49209 57
49210 58
49211 59
49212 60
49213 61
49214 62
49215 63
49216 64
49217 65
49218 66
49220 68
49221 69
49223 71
49225 73
49226 74
49227 75
49228 76
50187 11
50202 26
50226 50
50227 51
50230 54
50231 55
50232 56
51224 24
51249 49
52235 11
52250 26
52273 49
52276 52
52277 53
52278 54
52279 55
53287 39
53299 51
54323 51
55322 26
55345 49
55347 51
55351 55
56331 11
56336 16
56345 25
56346 26
56359 39
56361 41
56368 48
56369 49
56371 51
56374 54
56376 56
56377 57
56378 58
56379 59
56381 61
56382 62
56383 63
56384 64
56385 65
57393 49
57399 55
58409 41
58416 48
58423 55
58426 58
58427 59
58429 61
58430 62
58431 63
58432 64
58433 65
58435 67
59403 11
59419 27
59440 48
59447 55
59449 57
59451 59
59452 60
59453 61
59454 62
59455 63
59456 64
59457 65
59458 66
59462 70
59468 76
60464 48
60471 55
60473 57
60474 58
60476 60
60477 61
60478 62
60479 63
60480 64
60481 65
60482 66
61488 48
61498 58
61499 59
61501 61
61502 62
61503 63
61504 64
61505 65
61506 66
62512 48
62519 55
62521 57
62522 58
62523 59
62524 60
62526 62
62527 63
62528 64
62529 65
62530 66
63529 41
63536 48
63543 55
63545 57
63546 58
63547 59
63548 60
63549 61
63551 63
63552 64
63553 65
63554 66
63564 76
64560 48
64567 55
64569 57
64570 58
64571 59
64572 60
64573 61
64574 62
64576 64
64577 65
64578 66
64588 76
65547 11
65584 48
65591 55
65593 57
65594 58
65595 59
65596 60
65597 61
65598 62
65599 63
65601 65
65602 66
65612 76
66608 48
66615 55
66617 57
66618 58
66619 59
66620 60
66621 61
66622 62
66623 63
66624 64
66626 66
66636 76
67632 48
67642 58
67643 59
67644 60
67645 61
67646 62
67647 63
67648 64
67649 65
67660 76
68665 57
69643 11
69656 24
69657 25
69659 27
69673 41
69680 48
69701 69
69702 70
69703 71
69707 75
70667 11
70680 24
70681 25
70683 27
70697 41
70704 48
70724 68
70726 70
70727 71
70731 75
71691 11
71704 24
71705 25
71707 27
71721 41
71738 58
71748 68
71749 69
71751 71
71755 75
72715 11
72729 25
72731 27
72745 41
72752 48
72772 68
72773 69
72774 70
72779 75
73739 11
73754 26
73755 27
74800 48
74826 74
75824 48
75849 73
76825 25
76841 41
76848 48
76868 68
76869 69
76870 70
76871 71
77872 48
77882 58
77886 62
77887 63
77888 64
77889 65
77890 66
*Links
1 1024 1
2 2048 8
2 2051 6
2 2059 3
3 3072 10
3 3074 6
3 3083 3
4 4096 1
5 5120 1
6 6144 1
7 7168 1
8 8192 2
9 9216 1
11 11264 5
11 11266 3
11 11267 3
11 11274 10
11 11276 10
11 11277 10
11 11278 10
11 11279 10
11 11287 90
11 11288 70
11 11289 120
11 11290 310
11 11291 170
11 11292 80
11 11293 20
11 11295 30
11 11296 10
11 11297 20
11 11298 30
11 11299 30
11 11300 20
11 11301 20
11 11302 20
11 11307 30
11 11308 10
11 11312 10
11 11313 20
11 11315 20
11 11319 190
11 11322 40
11 11328 10
11 11332 10
11 11333 10
11 11334 10
11 11335 10
11 11336 10
1024 1 1
1024 2 80
1024 3 100
1024 4 10
1024 5 10
1024 6 10
1024 7 10
1024 8 20
1024 9 10
1024 11 50
2048 1 10
2048 2 8
2048 3 10
2048 4 10
2048 5 10
2048 6 10
2048 7 10
2048 8 20
2048 9 10
2048 11 5
2051 3072 10
2051 3074 6
2051 3083 3
2059 11264 5
2059 11266 3
2059 11267 3
2059 11274 10
2059 11276 10
2059 11277 10
2059 11278 10
2059 11279 10
2059 11287 90
2059 11288 70
2059 11289 120
2059 11290 310
2059 11291 170
2059 11292 80
2059 11293 20
2059 11295 30
2059 11296 10
2059 11297 20
2059 11298 30
2059 11299 30
2059 11300 20
2059 11301 20
2059 11302 20
2059 11307 30
2059 11308 10
2059 11312 10
2059 11313 20
2059 11315 20
2059 11319 190
2059 11322 40
2059 11328 10
2059 11332 10
2059 11333 10
2059 11334 10
2059 11335 10
2059 11336 10
3072 1 10
3072 2 8
3072 3 10
3072 4 10
3072 5 10
3072 6 10
3072 7 10
3072 8 20
3072 9 10
3072 11 5
3074 2048 8
3074 2051 6
3074 2059 3
3083 11264 5
3083 11266 3
3083 11267 3
3083 11274 10
3083 11276 10
3083 11277 10
3083 11278 10
3083 11279 10
3083 11287 90
3083 11288 70
3083 11289 120
3083 11290 310
3083 11291 170
3083 11292 80
3083 11293 20
3083 11295 30
3083 11296 10
3083 11297 20
3083 11298 30
3083 11299 30
3083 11300 20
3083 11301 20
3083 11302 20
3083 11307 30
3083 11308 10
3083 11312 10
3083 11313 20
3083 11315 20
3083 11319 190
3083 11322 40
3083 11328 10
3083 11332 10
3083 11333 10
3083 11334 10
3083 11335 10
3083 11336 10
4096 1 10
4096 2 80
4096 3 100
4096 4 1
4096 5 10
4096 6 10
4096 7 10
4096 8 20
4096 9 10
4096 11 50
5120 1 10
5120 2 80
5120 3 100
5120 4 10
5120 5 1
5120 6 10
5120 7 10
5120 8 20
5120 9 10
5120 11 50
6144 1 10
6144 2 80
6144 3 100
6144 4 10
6144 5 10
6144 6 1
6144 7 10
6144 8 20
6144 9 10
6144 11 50
7168 1 10
7168 2 80
7168 3 100
7168 4 10
7168 5 10
7168 6 10
7168 7 1
7168 8 20
7168 9 10
7168 11 50
8192 1 10
8192 2 80
8192 3 100
8192 4 10
8192 5 10
8192 6 10
8192 7 10
8192 8 2
8192 9 10
8192 11 50
9216 1 10
9216 2 80
9216 3 100
9216 4 10
9216 5 10
9216 6 10
9216 7 10
9216 8 20
9216 9 1
9216 11 50
10251 11264 50
10251 11266 30
10251 11267 30
10251 11274 1
10251 11276 10
10251 11277 10
10251 11278 10
10251 11279 10
10251 11287 90
10251 11288 70
10251 11289 120
10251 11290 310
10251 11291 170
10251 11292 80
10251 11293 20
10251 11295 30
10251 11296 10
10251 11297 20
10251 11298 30
10251 11299 30
10251 11300 20
10251 11301 20
10251 11302 20
10251 11307 30
10251 11308 10
10251 11312 10
10251 11313 20
10251 11315 20
10251 11319 190
10251 11322 40
10251 11328 10
10251 11332 10
10251 11333 10
10251 11334 10
10251 11335 10
10251 11336 10
11264 1 10
11264 2 8
11264 3 10
11264 4 10
11264 5 10
11264 6 10
11264 7 10
11264 8 20
11264 9 10
11264 11 5
11266 2048 8
11266 2051 6
11266 2059 3
11267 3072 10
11267 3074 6
11267 3083 3
11274 10251 1
11276 12299 1
11276 12311 2
11277 13323 1
11278 14347 1
11279 15371 1
11287 23563 9
11287 23564 2
11287 23568 30
11287 23569 30
11287 23570 30
11287 23571 30
11287 23572 40
11287 23573 40
11287 23574 40
11287 23576 2
11287 23577 1
11287 23579 5
11287 23581 1
11287 23582 10
11287 23583 2
11288 24587 7
11288 24599 2
11288 24601 13
11288 24602 4
11288 24603 1
11288 24617 20
11288 24618 10
11288 24626 10
11288 24644 1
11288 24645 1
11288 24646 1
11289 25611 12
11289 25623 1
11289 25624 13
11289 25626 1
11289 25627 5
11289 25639 10
11289 25640 10
11289 25641 30
11289 25642 20
11289 25648 1
11289 25655 2
11289 25668 5
11289 25669 6
11289 25670 4
11289 25671 1
11289 25675 30
11290 26635 31
11290 26640 10
11290 26648 4
11290 26649 1
11290 26651 1
11290 26667 1
11290 26673 3
11290 26675 2
11290 26678 10
11290 26679 21
11290 26696 2
11291 27659 17
11291 27671 5
11291 27672 1
11291 27673 5
11291 27674 1
11291 27676 1
11291 27677 1
11291 27679 1
11291 27681 1
11291 27691 1
11291 27696 1
11291 27706 6
11291 27716 1
11291 27717 2
11291 27718 1
11291 27719 1
11291 27720 1
11292 28683 8
11292 28699 1
11292 28716 3
11292 28717 20
11293 29707 2
11293 29719 1
11293 29723 1
11293 29730 2
11293 29731 2
11293 29732 1
11293 29733 1
11293 29734 1
11295 31755 3
11295 31767 2
11295 31771 1
11295 31774 20
11296 32779 1
11297 33803 2
11297 33819 1
11298 34827 3
11298 34845 2
11298 34851 3
11298 34852 2
11298 34853 2
11298 34854 2
11299 35851 3
11299 35869 2
11299 35874 3
11299 35876 2
11299 35877 2
11299 35878 2
11300 36875 2
11300 36893 1
11300 36898 2
11300 36899 2
11300 36901 2
11300 36902 2
11301 37899 2
11301 37917 1
11301 37922 2
11301 37923 2
11301 37924 2
11301 37926 2
11302 38923 2
11302 38941 1
11302 38946 2
11302 38947 2
11302 38948 2
11302 38949 2
11307 44043 3
11307 44058 1
11307 44059 1
11308 45067 1
11308 45084 3
11312 49163 1
11312 49177 1
11312 49179 1
11312 49199 20
11312 49207 4
11312 49209 10
11312 49210 7
11312 49211 60
11312 49212 10
11312 49213 20
11312 49214 70
11312 49215 50
11312 49216 5
11312 49217 30
11312 49218 10
11312 49220 1
11312 49221 1
11312 49223 1
11312 49225 20
11312 49226 20
11312 49227 10
11312 49228 10
11313 50187 2
11313 50202 3
11313 50226 10
11313 50227 9
11313 50230 10
11313 50231 12
11313 50232 10
11315 52235 2
11315 52250 2
11315 52273 9
11315 52276 10
11315 52277 10
11315 52278 20
11315 52279 6
11319 56331 19
11319 56336 10
11319 56345 2
11319 56346 21
11319 56359 10
11319 56361 50
11319 56368 4
11319 56369 12
11319 56371 6
11319 56374 10
11319 56376 10
11319 56377 10
11319 56378 7
11319 56379 50
11319 56381 10
11319 56382 90
11319 56383 10
11319 56384 5
11319 56385 20
11322 59403 4
11322 59419 6
11322 59440 7
11322 59447 7
11322 59449 10
11322 59451 150
11322 59452 40
11322 59453 60
11322 59454 170
11322 59455 40
11322 59456 10
11322 59457 50
11322 59458 30
11322 59462 1
11322 59468 10
11328 65547 1
11328 65584 5
11328 65591 5
11328 65593 10
11328 65594 10
11328 65595 90
11328 65596 20
11328 65597 60
11328 65598 120
11328 65599 40
11328 65601 70
11328 65602 30
11328 65612 10
11332 69643 1
11332 69656 1
11332 69657 5
11332 69659 1
11332 69673 10
11332 69680 1
11332 69701 6
11332 69702 4
11332 69703 2
11332 69707 30
11333 70667 1
11333 70680 1
11333 70681 6
11333 70683 2
11333 70697 10
11333 70704 1
11333 70724 6
11333 70726 4
11333 70727 2
11333 70731 30
11334 71691 1
11334 71704 1
11334 71705 4
11334 71707 1
11334 71721 10
11334 71738 1
11334 71748 4
11334 71749 4
11334 71751 2
11334 71755 10
11335 72715 1
11335 72729 1
11335 72731 1
11335 72745 10
11335 72752 1
11335 72772 2
11335 72773 2
11335 72774 2
11335 72779 10
11336 73739 1
11336 73754 2
11336 73755 1
12299 11264 50
12299 11266 30
12299 11267 30
12299 11274 10
12299 11276 1
12299 11277 10
12299 11278 10
12299 11279 10
12299 11287 9
12299 11288 70
12299 11289 120
12299 11290 310
12299 11291 170
12299 11292 80
12299 11293 20
12299 11295 30
12299 11296 10
12299 11297 20
12299 11298 30
12299 11299 30
12299 11300 20
12299 11301 20
12299 11302 20
12299 11307 30
12299 11308 10
12299 11312 10
12299 11313 20
12299 11315 20
12299 11319 190
12299 11322 40
12299 11328 10
12299 11332 10
12299 11333 10
12299 11334 10
12299 11335 10
12299 11336 10
12311 23563 9
12311 23564 2
12311 23568 30
12311 23569 30
12311 23570 30
12311 23571 30
12311 23572 40
12311 23573 40
12311 23574 40
12311 23576 20
12311 23577 10
12311 23579 50
12311 23581 10
12311 23582 10
12311 23583 20
13323 11264 50
13323 11266 30
13323 11267 30
13323 11274 10
13323 11276 10
13323 11277 1
13323 11278 10
13323 11279 10
13323 11287 90
13323 11288 70
13323 11289 120
13323 11290 310
13323 11291 170
13323 11292 80
13323 11293 20
13323 11295 30
13323 11296 10
13323 11297 20
13323 11298 30
13323 11299 30
13323 11300 20
13323 11301 20
13323 11302 20
13323 11307 30
13323 11308 10
13323 11312 10
13323 11313 20
13323 11315 20
13323 11319 190
13323 11322 40
13323 11328 10
13323 11332 10
13323 11333 10
13323 11334 10
13323 11335 10
13323 11336 10
14347 11264 50
14347 11266 30
14347 11267 30
14347 11274 10
14347 11276 10
14347 11277 10
14347 11278 1
14347 11279 10
14347 11287 90
14347 11288 70
14347 11289 120
14347 11290 310
14347 11291 170
14347 11292 80
14347 11293 20
14347 11295 30
14347 11296 10
14347 11297 20
14347 11298 30
14347 11299 30
14347 11300 20
14347 11301 20
14347 11302 20
14347 11307 30
14347 11308 10
14347 11312 10
14347 11313 20
14347 11315 20
14347 11319 190
14347 11322 40
14347 11328 10
14347 11332 10
14347 11333 10
14347 11334 10
14347 11335 10
14347 11336 10
15371 11264 50
15371 11266 30
15371 11267 30
15371 11274 10
15371 11276 10
15371 11277 10
15371 11278 10
15371 11279 1
15371 11287 90
15371 11288 70
15371 11289 120
15371 11290 310
15371 11291 170
15371 11292 80
15371 11293 20
15371 11295 30
15371 11296 10
15371 11297 20
15371 11298 30
15371 11299 30
15371 11300 20
15371 11301 20
15371 11302 20
15371 11307 30
15371 11308 10
15371 11312 10
15371 11313 20
15371 11315 20
15371 11319 190
15371 11322 40
15371 11328 10
15371 11332 10
15371 11333 10
15371 11334 10
15371 11335 10
15371 11336 10
16401 17424 4
16401 17426 4
16401 17427 4
16401 17428 3
16401 17429 3
16401 17430 3
16401 17431 3
16402 18448 4
16402 18449 4
16402 18451 4
16402 18452 3
16402 18453 3
16402 18454 3
16402 18455 3
16403 19472 4
16403 19473 4
16403 19474 4
16403 19476 4
16403 19477 3
16403 19478 3
16403 19479 3
16404 20496 3
16404 20497 3
16404 20498 3
16404 20499 4
16404 20501 5
16404 20502 4
16404 20503 4
16405 21520 3
16405 21521 3
16405 21522 3
16405 21523 3
16405 21524 5
16405 21526 4
16405 21527 4
16406 22544 3
16406 22545 3
16406 22546 3
16406 22547 3
16406 22548 4
16406 22549 4
16406 22551 4
16407 23563 90
16407 23564 20
16407 23568 3
16407 23569 3
16407 23570 3
16407 23571 3
16407 23572 4
16407 23573 4
16407 23574 4
16407 23576 20
16407 23577 10
16407 23579 50
16407 23581 10
16407 23582 10
16407 23583 20
16410 26635 310
16410 26640 1
16410 26648 40
16410 26649 10
16410 26651 10
16410 26667 10
16410 26673 30
16410 26675 20
16410 26678 10
16410 26679 21
16410 26696 20
16439 56331 190
16439 56336 1
16439 56345 20
16439 56346 21
16439 56359 10
16439 56361 50
16439 56368 40
16439 56369 120
16439 56371 60
16439 56374 10
16439 56376 10
16439 56377 10
16439 56378 70
16439 56379 50
16439 56381 10
16439 56382 90
16439 56383 10
16439 56384 50
16439 56385 20
17424 16401 4
17424 16402 4
17424 16403 4
17424 16404 3
17424 16405 3
17424 16406 3
17424 16407 3
17424 16410 10
17424 16439 10
17426 18448 4
17426 18449 4
17426 18451 4
17426 18452 3
17426 18453 3
17426 18454 3
17426 18455 3
17427 19472 4
17427 19473 4
17427 19474 4
17427 19476 4
17427 19477 3
17427 19478 3
17427 19479 3
17428 20496 3
17428 20497 3
17428 20498 3
17428 20499 4
17428 20501 5
17428 20502 4
17428 20503 4
17429 21520 3
17429 21521 3
17429 21522 3
17429 21523 3
17429 21524 5
17429 21526 4
17429 21527 4
17430 22544 3
17430 22545 3
17430 22546 3
17430 22547 3
17430 22548 4
17430 22549 4
17430 22551 4
17431 23563 90
17431 23564 20
17431 23568 3
17431 23569 3
17431 23570 3
17431 23571 3
17431 23572 4
17431 23573 4
17431 23574 4
17431 23576 20
17431 23577 10
17431 23579 50
17431 23581 10
17431 23582 10
17431 23583 20
18448 16401 4
18448 16402 4
18448 16403 4
18448 16404 3
18448 16405 3
18448 16406 3
18448 16407 3
18448 16410 10
18448 16439 10
18449 17424 4
18449 17426 4
18449 17427 4
18449 17428 3
18449 17429 3
18449 17430 3
18449 17431 3
18451 19472 4
18451 19473 4
18451 19474 4
18451 19476 4
18451 19477 3
18451 19478 3
18451 19479 3
18452 20496 3
18452 20497 3
18452 20498 3
18452 20499 4
18452 20501 5
18452 20502 4
18452 20503 4
18453 21520 3
18453 21521 3
18453 21522 3
18453 21523 3
18453 21524 5
18453 21526 4
18453 21527 4
18454 22544 3
18454 22545 3
18454 22546 3
18454 22547 3
18454 22548 4
18454 22549 4
18454 22551 4
18455 23563 90
18455 23564 20
18455 23568 3
18455 23569 3
18455 23570 3
18455 23571 3
18455 23572 4
18455 23573 4
18455 23574 4
18455 23576 20
18455 23577 10
18455 23579 50
18455 23581 10
18455 23582 10
18455 23583 20
19472 16401 4
19472 16402 4
19472 16403 4
19472 16404 3
19472 16405 3
19472 16406 3
19472 16407 3
19472 16410 10
19472 16439 10
19473 17424 4
19473 17426 4
19473 17427 4
19473 17428 3
19473 17429 3
19473 17430 3
19473 17431 3
19474 18448 4
19474 18449 4
19474 18451 4
19474 18452 3
19474 18453 3
19474 18454 3
19474 18455 3
19476 20496 3
19476 20497 3
19476 20498 3
19476 20499 4
19476 20501 5
19476 20502 4
19476 20503 4
19477 21520 3
19477 21521 3
19477 21522 3
19477 21523 3
19477 21524 5
19477 21526 4
19477 21527 4
19478 22544 3
19478 22545 3
19478 22546 3
19478 22547 3
19478 22548 4
19478 22549 4
19478 22551 4
19479 23563 90
19479 23564 20
19479 23568 3
19479 23569 3
19479 23570 3
19479 23571 3
19479 23572 4
19479 23573 4
19479 23574 4
19479 23576 20
19479 23577 10
19479 23579 50
19479 23581 10
19479 23582 10
19479 23583 20
20496 16401 4
20496 16402 4
20496 16403 4
20496 16404 3
20496 16405 3
20496 16406 3
20496 16407 3
20496 16410 10
20496 16439 10
20497 17424 4
20497 17426 4
20497 17427 4
20497 17428 3
20497 17429 3
20497 17430 3
20497 17431 3
20498 18448 4
20498 18449 4
20498 18451 4
20498 18452 3
20498 18453 3
20498 18454 3
20498 18455 3
20499 19472 4
20499 19473 4
20499 19474 4
20499 19476 4
20499 19477 3
20499 19478 3
20499 19479 3
20501 21520 3
20501 21521 3
20501 21522 3
20501 21523 3
20501 21524 5
20501 21526 4
20501 21527 4
20502 22544 3
20502 22545 3
20502 22546 3
20502 22547 3
20502 22548 4
20502 22549 4
20502 22551 4
20503 23563 90
20503 23564 20
20503 23568 3
20503 23569 3
20503 23570 3
20503 23571 3
20503 23572 4
20503 23573 4
20503 23574 4
20503 23576 20
20503 23577 10
20503 23579 50
20503 23581 10
20503 23582 10
20503 23583 20
21520 16401 4
21520 16402 4
21520 16403 4
21520 16404 3
21520 16405 3
21520 16406 3
21520 16407 3
21520 16410 10
21520 16439 10
21521 17424 4
21521 17426 4
21521 17427 4
21521 17428 3
21521 17429 3
21521 17430 3
21521 17431 3
21522 18448 4
21522 18449 4
21522 18451 4
21522 18452 3
21522 18453 3
21522 18454 3
21522 18455 3
21523 19472 4
21523 19473 4
21523 19474 4
21523 19476 4
21523 19477 3
21523 19478 3
21523 19479 3
21524 20496 3
21524 20497 3
21524 20498 3
21524 20499 4
21524 20501 5
21524 20502 4
21524 20503 4
21526 22544 3
21526 22545 3
21526 22546 3
21526 22547 3
21526 22548 4
21526 22549 4
21526 22551 4
21527 23563 90
21527 23564 20
21527 23568 3
21527 23569 3
21527 23570 3
21527 23571 3
21527 23572 4
21527 23573 4
21527 23574 4
21527 23576 20
21527 23577 10
21527 23579 50
21527 23581 10
21527 23582 10
21527 23583 20
22544 16401 4
22544 16402 4
22544 16403 4
22544 16404 3
22544 16405 3
22544 16406 3
22544 16407 3
22544 16410 10
22544 16439 10
22545 17424 4
22545 17426 4
22545 17427 4
22545 17428 3
22545 17429 3
22545 17430 3
22545 17431 3
22546 18448 4
22546 18449 4
22546 18451 4
22546 18452 3
22546 18453 3
22546 18454 3
22546 18455 3
22547 19472 4
22547 19473 4
22547 19474 4
22547 19476 4
22547 19477 3
22547 19478 3
22547 19479 3
22548 20496 3
22548 20497 3
22548 20498 3
22548 20499 4
22548 20501 5
22548 20502 4
22548 20503 4
22549 21520 3
22549 21521 3
22549 21522 3
22549 21523 3
22549 21524 5
22549 21526 4
22549 21527 4
22551 23563 90
22551 23564 20
22551 23568 3
22551 23569 3
22551 23570 3
22551 23571 3
22551 23572 4
22551 23573 4
22551 23574 4
22551 23576 20
22551 23577 10
22551 23579 50
22551 23581 10
22551 23582 10
22551 23583 20
23563 11264 50
23563 11266 30
23563 11267 30
23563 11274 10
23563 11276 1
23563 11277 10
23563 11278 10
23563 11279 10
23563 11287 9
23563 11288 7
23563 11289 12
23563 11290 310
23563 11291 17
23563 11292 80
23563 11293 2
23563 11295 3
23563 11296 10
23563 11297 20
23563 11298 30
23563 11299 30
23563 11300 20
23563 11301 20
23563 11302 20
23563 11307 30
23563 11308 10
23563 11312 10
23563 11313 20
23563 11315 20
23563 11319 190
23563 11322 40
23563 11328 10
23563 11332 10
23563 11333 10
23563 11334 10
23563 11335 10
23563 11336 10
23564 12299 1
23564 12311 2
23568 16401 4
23568 16402 4
23568 16403 4
23568 16404 3
23568 16405 3
23568 16406 3
23568 16407 3
23568 16410 10
23568 16439 10
23569 17424 4
23569 17426 4
23569 17427 4
23569 17428 3
23569 17429 3
23569 17430 3
23569 17431 3
23570 18448 4
23570 18449 4
23570 18451 4
23570 18452 3
23570 18453 3
23570 18454 3
23570 18455 3
23571 19472 4
23571 19473 4
23571 19474 4
23571 19476 4
23571 19477 3
23571 19478 3
23571 19479 3
23572 20496 3
23572 20497 3
23572 20498 3
23572 20499 4
23572 20501 5
23572 20502 4
23572 20503 4
23573 21520 3
23573 21521 3
23573 21522 3
23573 21523 3
23573 21524 5
23573 21526 4
23573 21527 4
23574 22544 3
23574 22545 3
23574 22546 3
23574 22547 3
23574 22548 4
23574 22549 4
23574 22551 4
23576 24587 7
23576 24599 2
23576 24601 13
23576 24602 40
23576 24603 1
23576 24617 20
23576 24618 10
23576 24626 10
23576 24644 10
23576 24645 10
23576 24646 10
23577 25611 12
23577 25623 1
23577 25624 13
23577 25626 10
23577 25627 5
23577 25639 10
23577 25640 10
23577 25641 30
23577 25642 20
23577 25648 10
23577 25655 20
23577 25668 50
23577 25669 60
23577 25670 40
23577 25671 10
23577 25675 30
23579 27659 17
23579 27671 5
23579 27672 1
23579 27673 5
23579 27674 10
23579 27676 10
23579 27677 1
23579 27679 1
23579 27681 10
23579 27691 10
23579 27696 10
23579 27706 60
23579 27716 10
23579 27717 20
23579 27718 10
23579 27719 10
23579 27720 10
23581 29707 2
23581 29719 1
23581 29723 1
23581 29730 20
23581 29731 20
23581 29732 10
23581 29733 10
23581 29734 10
23582 30743 1
23582 30751 2
23583 31755 3
23583 31767 2
23583 31771 1
23583 31774 2
24587 11264 50
24587 11266 30
24587 11267 30
24587 11274 10
24587 11276 10
24587 11277 10
24587 11278 10
24587 11279 10
24587 11287 9
24587 11288 7
24587 11289 12
24587 11290 31
24587 11291 17
24587 11292 80
24587 11293 20
24587 11295 30
24587 11296 10
24587 11297 20
24587 11298 30
24587 11299 30
24587 11300 20
24587 11301 20
24587 11302 20
24587 11307 30
24587 11308 10
24587 11312 10
24587 11313 20
24587 11315 20
24587 11319 190
24587 11322 40
24587 11328 10
24587 11332 1
24587 11333 1
24587 11334 1
24587 11335 10
24587 11336 10
24599 23563 9
24599 23564 20
24599 23568 30
24599 23569 30
24599 23570 30
24599 23571 30
24599 23572 40
24599 23573 40
24599 23574 40
24599 23576 2
24599 23577 1
24599 23579 5
24599 23581 10
24599 23582 10
24599 23583 20
24601 25611 12
24601 25623 1
24601 25624 13
24601 25626 1
24601 25627 5
24601 25639 10
24601 25640 10
24601 25641 3
24601 25642 2
24601 25648 10
24601 25655 20
24601 25668 5
24601 25669 6
24601 25670 4
24601 25671 10
24601 25675 30
24602 26635 31
24602 26640 10
24602 26648 4
24602 26649 1
24602 26651 1
24602 26667 10
24602 26673 30
24602 26675 20
24602 26678 10
24602 26679 210
24602 26696 20
24603 27659 17
24603 27671 5
24603 27672 1
24603 27673 5
24603 27674 1
24603 27676 10
24603 27677 10
24603 27679 10
24603 27681 10
24603 27691 10
24603 27696 10
24603 27706 60
24603 27716 1
24603 27717 2
24603 27718 1
24603 27719 10
24603 27720 10
24617 42008 2
24617 42009 3
24617 42026 2
24617 42039 50
24617 42041 10
24617 42046 10
24617 42052 1
24617 42053 1
24617 42054 1
24617 42055 10
24617 42059 10
24618 43032 1
24618 43033 2
24618 43049 2
24626 51224 1
24626 51249 10
24644 69643 1
24644 69656 1
24644 69657 5
24644 69659 1
24644 69673 1
24644 69680 10
24644 69701 6
24644 69702 4
24644 69703 20
24644 69707 30
24645 70667 1
24645 70680 1
24645 70681 6
24645 70683 2
24645 70697 1
24645 70704 10
24645 70724 6
24645 70726 4
24645 70727 20
24645 70731 30
24646 71691 1
24646 71704 1
24646 71705 4
24646 71707 1
24646 71721 1
24646 71738 10
24646 71748 4
24646 71749 4
24646 71751 20
24646 71755 10
25611 11264 50
25611 11266 30
25611 11267 30
25611 11274 10
25611 11276 10
25611 11277 10
25611 11278 10
25611 11279 10
25611 11287 9
25611 11288 7
25611 11289 12
25611 11290 31
25611 11291 17
25611 11292 80
25611 11293 20
25611 11295 30
25611 11296 10
25611 11297 20
25611 11298 30
25611 11299 30
25611 11300 20
25611 11301 20
25611 11302 20
25611 11307 30
25611 11308 10
25611 11312 1
25611 11313 20
25611 11315 20
25611 11319 19
25611 11322 40
25611 11328 10
25611 11332 1
25611 11333 1
25611 11334 1
25611 11335 1
25611 11336 10
25623 23563 9
25623 23564 20
25623 23568 30
25623 23569 30
25623 23570 30
25623 23571 30
25623 23572 40
25623 23573 40
25623 23574 40
25623 23576 2
25623 23577 1
25623 23579 5
25623 23581 10
25623 23582 10
25623 23583 20
25624 24587 7
25624 24599 2
25624 24601 13
25624 24602 4
25624 24603 1
25624 24617 2
25624 24618 1
25624 24626 10
25624 24644 1
25624 24645 1
25624 24646 1
25626 26635 31
25626 26640 10
25626 26648 4
25626 26649 1
25626 26651 1
25626 26667 10
25626 26673 30
25626 26675 20
25626 26678 10
25626 26679 21
25626 26696 20
25627 27659 17
25627 27671 5
25627 27672 1
25627 27673 5
25627 27674 1
25627 27676 10
25627 27677 10
25627 27679 10
25627 27681 10
25627 27691 10
25627 27696 1
25627 27706 60
25627 27716 1
25627 27717 2
25627 27718 1
25627 27719 1
25627 27720 10
25639 39961 1
25639 39988 10
25639 39991 1
25640 40985 1
25641 42008 2
25641 42009 3
25641 42026 2
25641 42039 5
25641 42041 10
25641 42046 10
25641 42052 1
25641 42053 1
25641 42054 1
25641 42055 1
25641 42059 1
25642 43032 1
25642 43033 2
25642 43049 2
25648 49163 1
25648 49177 1
25648 49179 1
25648 49199 20
25648 49207 4
25648 49209 10
25648 49210 70
25648 49211 60
25648 49212 10
25648 49213 20
25648 49214 70
25648 49215 50
25648 49216 50
25648 49217 30
25648 49218 10
25648 49220 1
25648 49221 1
25648 49223 1
25648 49225 20
25648 49226 20
25648 49227 1
25648 49228 10
25655 56331 19
25655 56336 10
25655 56345 2
25655 56346 21
25655 56359 1
25655 56361 5
25655 56368 4
25655 56369 120
25655 56371 60
25655 56374 10
25655 56376 10
25655 56377 10
25655 56378 70
25655 56379 50
25655 56381 10
25655 56382 90
25655 56383 10
25655 56384 50
25655 56385 20
25668 69643 1
25668 69656 1
25668 69657 5
25668 69659 1
25668 69673 1
25668 69680 1
25668 69701 6
25668 69702 4
25668 69703 2
25668 69707 3
25669 70667 1
25669 70680 1
25669 70681 6
25669 70683 2
25669 70697 1
25669 70704 1
25669 70724 6
25669 70726 4
25669 70727 2
25669 70731 3
25670 71691 1
25670 71704 1
25670 71705 4
25670 71707 1
25670 71721 1
25670 71738 10
25670 71748 4
25670 71749 4
25670 71751 2
25670 71755 1
25671 72715 1
25671 72729 1
25671 72731 1
25671 72745 1
25671 72752 1
25671 72772 2
25671 72773 2
25671 72774 2
25671 72779 1
25675 76825 3
25675 76841 1
25675 76848 1
25675 76868 3
25675 76869 3
25675 76870 1
25675 76871 1
26635 11264 50
26635 11266 30
26635 11267 30
26635 11274 10
26635 11276 10
26635 11277 10
26635 11278 10
26635 11279 10
26635 11287 90
26635 11288 7
26635 11289 12
26635 11290 31
26635 11291 17
26635 11292 80
26635 11293 20
26635 11295 30
26635 11296 10
26635 11297 20
26635 11298 30
26635 11299 30
26635 11300 20
26635 11301 20
26635 11302 20
26635 11307 3
26635 11308 10
26635 11312 10
26635 11313 2
26635 11315 2
26635 11319 19
26635 11322 40
26635 11328 10
26635 11332 10
26635 11333 10
26635 11334 10
26635 11335 10
26635 11336 1
26640 16401 40
26640 16402 40
26640 16403 40
26640 16404 30
26640 16405 30
26640 16406 30
26640 16407 30
26640 16410 1
26640 16439 1
26648 24587 7
26648 24599 20
26648 24601 13
26648 24602 4
26648 24603 1
26648 24617 20
26648 24618 10
26648 24626 10
26648 24644 10
26648 24645 10
26648 24646 10
26649 25611 12
26649 25623 10
26649 25624 13
26649 25626 1
26649 25627 5
26649 25639 10
26649 25640 10
26649 25641 30
26649 25642 20
26649 25648 10
26649 25655 2
26649 25668 50
26649 25669 60
26649 25670 40
26649 25671 10
26649 25675 30
26651 27659 17
26651 27671 50
26651 27672 1
26651 27673 5
26651 27674 1
26651 27676 10
26651 27677 10
26651 27679 10
26651 27681 10
26651 27691 1
26651 27696 10
26651 27706 60
26651 27716 10
26651 27717 20
26651 27718 10
26651 27719 10
26651 27720 1
26667 44043 3
26667 44058 1
26667 44059 1
26673 50187 2
26673 50202 3
26673 50226 10
26673 50227 9
26673 50230 1
26673 50231 12
26673 50232 10
26675 52235 2
26675 52250 2
26675 52273 9
26675 52276 10
26675 52277 10
26675 52278 2
26675 52279 6
26678 55322 1
26678 55345 1
26678 55347 2
26678 55351 1
26679 56331 19
26679 56336 1
26679 56345 2
26679 56346 21
26679 56359 10
26679 56361 50
26679 56368 40
26679 56369 12
26679 56371 6
26679 56374 1
26679 56376 10
26679 56377 10
26679 56378 70
26679 56379 50
26679 56381 10
26679 56382 90
26679 56383 10
26679 56384 50
26679 56385 20
26696 73739 1
26696 73754 2
26696 73755 1
27659 11264 50
27659 11266 30
27659 11267 30
27659 11274 10
27659 11276 10
27659 11277 10
27659 11278 10
27659 11279 10
27659 11287 9
27659 11288 7
27659 11289 12
27659 11290 31
27659 11291 17
27659 11292 8
27659 11293 2
27659 11295 3
27659 11296 10
27659 11297 2
27659 11298 30
27659 11299 30
27659 11300 20
27659 11301 20
27659 11302 20
27659 11307 3
27659 11308 10
27659 11312 1
27659 11313 20
27659 11315 20
27659 11319 190
27659 11322 4
27659 11328 10
27659 11332 1
27659 11333 1
27659 11334 1
27659 11335 1
27659 11336 1
27671 23563 9
27671 23564 20
27671 23568 30
27671 23569 30
27671 23570 30
27671 23571 30
27671 23572 40
27671 23573 40
27671 23574 40
27671 23576 2
27671 23577 1
27671 23579 5
27671 23581 1
27671 23582 10
27671 23583 2
27672 24587 7
27672 24599 2
27672 24601 13
27672 24602 4
27672 24603 1
27672 24617 20
27672 24618 10
27672 24626 10
27672 24644 1
27672 24645 1
27672 24646 1
27673 25611 12
27673 25623 1
27673 25624 13
27673 25626 1
27673 25627 5
27673 25639 10
27673 25640 10
27673 25641 30
27673 25642 20
27673 25648 1
27673 25655 20
27673 25668 5
27673 25669 6
27673 25670 4
27673 25671 1
27673 25675 30
27674 26635 31
27674 26640 10
27674 26648 4
27674 26649 1
27674 26651 1
27674 26667 1
27674 26673 30
27674 26675 20
27674 26678 10
27674 26679 210
27674 26696 2
27676 28683 8
27676 28699 1
27676 28716 30
27676 28717 20
27677 29707 2
27677 29719 1
27677 29723 1
27677 29730 20
27677 29731 20
27677 29732 10
27677 29733 10
27677 29734 10
27679 31755 3
27679 31767 2
27679 31771 1
27679 31774 20
27681 33803 2
27681 33819 1
27691 44043 3
27691 44058 1
27691 44059 1
27696 49163 1
27696 49177 1
27696 49179 1
27696 49199 20
27696 49207 40
27696 49209 10
27696 49210 7
27696 49211 60
27696 49212 10
27696 49213 20
27696 49214 70
27696 49215 50
27696 49216 50
27696 49217 30
27696 49218 10
27696 49220 1
27696 49221 1
27696 49223 1
27696 49225 20
27696 49226 20
27696 49227 10
27696 49228 10
27706 59403 4
27706 59419 6
27706 59440 7
27706 59447 70
27706 59449 10
27706 59451 150
27706 59452 40
27706 59453 60
27706 59454 170
27706 59455 40
27706 59456 100
27706 59457 50
27706 59458 30
27706 59462 1
27706 59468 10
27716 69643 1
27716 69656 1
27716 69657 5
27716 69659 1
27716 69673 10
27716 69680 1
27716 69701 6
27716 69702 4
27716 69703 2
27716 69707 30
27717 70667 1
27717 70680 1
27717 70681 6
27717 70683 2
27717 70697 10
27717 70704 1
27717 70724 6
27717 70726 4
27717 70727 2
27717 70731 30
27718 71691 1
27718 71704 1
27718 71705 4
27718 71707 1
27718 71721 10
27718 71738 1
27718 71748 4
27718 71749 4
27718 71751 2
27718 71755 10
27719 72715 1
27719 72729 1
27719 72731 1
27719 72745 10
27719 72752 1
27719 72772 2
27719 72773 2
27719 72774 2
27719 72779 10
27720 73739 1
27720 73754 2
27720 73755 1
28683 11264 50
28683 11266 30
28683 11267 30
28683 11274 10
28683 11276 10
28683 11277 10
28683 11278 10
28683 11279 10
28683 11287 90
28683 11288 70
28683 11289 120
28683 11290 310
28683 11291 17
28683 11292 8
28683 11293 20
28683 11295 30
28683 11296 10
28683 11297 20
28683 11298 30
28683 11299 30
28683 11300 20
28683 11301 20
28683 11302 20
28683 11307 30
28683 11308 1
28683 11312 10
28683 11313 20
28683 11315 20
28683 11319 190
28683 11322 40
28683 11328 10
28683 11332 10
28683 11333 10
28683 11334 10
28683 11335 10
28683 11336 10
28699 27659 17
28699 27671 50
28699 27672 10
28699 27673 50
28699 27674 10
28699 27676 1
28699 27677 10
28699 27679 10
28699 27681 10
28699 27691 10
28699 27696 10
28699 27706 60
28699 27716 10
28699 27717 20
28699 27718 10
28699 27719 10
28699 27720 10
28716 45067 1
28716 45084 3
28717 46108 2
29707 11264 50
29707 11266 30
29707 11267 30
29707 11274 10
29707 11276 10
29707 11277 10
29707 11278 10
29707 11279 10
29707 11287 9
29707 11288 70
29707 11289 120
29707 11290 310
29707 11291 17
29707 11292 80
29707 11293 2
29707 11295 30
29707 11296 10
29707 11297 20
29707 11298 3
29707 11299 3
29707 11300 2
29707 11301 2
29707 11302 2
29707 11307 30
29707 11308 10
29707 11312 10
29707 11313 20
29707 11315 20
29707 11319 190
29707 11322 40
29707 11328 10
29707 11332 10
29707 11333 10
29707 11334 10
29707 11335 10
29707 11336 10
29719 23563 9
29719 23564 20
29719 23568 30
29719 23569 30
29719 23570 30
29719 23571 30
29719 23572 40
29719 23573 40
29719 23574 40
29719 23576 20
29719 23577 10
29719 23579 5
29719 23581 1
29719 23582 10
29719 23583 20
29723 27659 17
29723 27671 5
29723 27672 10
29723 27673 50
29723 27674 10
29723 27676 10
29723 27677 1
29723 27679 10
29723 27681 10
29723 27691 10
29723 27696 10
29723 27706 60
29723 27716 10
29723 27717 20
29723 27718 10
29723 27719 10
29723 27720 10
29730 34827 3
29730 34845 2
29730 34851 3
29730 34852 2
29730 34853 2
29730 34854 2
29731 35851 3
29731 35869 2
29731 35874 3
29731 35876 2
29731 35877 2
29731 35878 2
29732 36875 2
29732 36893 1
29732 36898 2
29732 36899 2
29732 36901 2
29732 36902 2
29733 37899 2
29733 37917 1
29733 37922 2
29733 37923 2
29733 37924 2
29733 37926 2
29734 38923 2
29734 38941 1
29734 38946 2
29734 38947 2
29734 38948 2
29734 38949 2
30743 23563 90
30743 23564 20
30743 23568 30
30743 23569 30
30743 23570 30
30743 23571 30
30743 23572 40
30743 23573 40
30743 23574 40
30743 23576 20
30743 23577 10
30743 23579 50
30743 23581 10
30743 23582 1
30743 23583 2
30751 31755 30
30751 31767 2
30751 31771 10
30751 31774 2
31755 11264 50
31755 11266 30
31755 11267 30
31755 11274 10
31755 11276 10
31755 11277 10
31755 11278 10
31755 11279 10
31755 11287 9
31755 11288 70
31755 11289 120
31755 11290 310
31755 11291 17
31755 11292 80
31755 11293 20
31755 11295 3
31755 11296 10
31755 11297 20
31755 11298 30
31755 11299 30
31755 11300 20
31755 11301 20
31755 11302 20
31755 11307 30
31755 11308 10
31755 11312 10
31755 11313 20
31755 11315 20
31755 11319 190
31755 11322 40
31755 11328 10
31755 11332 10
31755 11333 10
31755 11334 10
31755 11335 10
31755 11336 10
31767 23563 9
31767 23564 20
31767 23568 30
31767 23569 30
31767 23570 30
31767 23571 30
31767 23572 40
31767 23573 40
31767 23574 40
31767 23576 20
31767 23577 10
31767 23579 5
31767 23581 10
31767 23582 1
31767 23583 2
31771 27659 17
31771 27671 5
31771 27672 10
31771 27673 50
31771 27674 10
31771 27676 10
31771 27677 10
31771 27679 1
31771 27681 10
31771 27691 10
31771 27696 10
31771 27706 60
31771 27716 10
31771 27717 20
31771 27718 10
31771 27719 10
31771 27720 10
31774 30743 1
31774 30751 2
32779 11264 50
32779 11266 30
32779 11267 30
32779 11274 10
32779 11276 10
32779 11277 10
32779 11278 10
32779 11279 10
32779 11287 90
32779 11288 70
32779 11289 120
32779 11290 310
32779 11291 170
32779 11292 80
32779 11293 20
32779 11295 30
32779 11296 1
32779 11297 20
32779 11298 30
32779 11299 30
32779 11300 20
32779 11301 20
32779 11302 20
32779 11307 30
32779 11308 10
32779 11312 10
32779 11313 20
32779 11315 20
32779 11319 190
32779 11322 40
32779 11328 10
32779 11332 10
32779 11333 10
32779 11334 10
32779 11335 10
32779 11336 10
33803 11264 50
33803 11266 30
33803 11267 30
33803 11274 10
33803 11276 10
33803 11277 10
33803 11278 10
33803 11279 10
33803 11287 90
33803 11288 70
33803 11289 120
33803 11290 310
33803 11291 17
33803 11292 80
33803 11293 20
33803 11295 30
33803 11296 10
33803 11297 2
33803 11298 30
33803 11299 30
33803 11300 20
33803 11301 20
33803 11302 20
33803 11307 30
33803 11308 10
33803 11312 10
33803 11313 20
33803 11315 20
33803 11319 190
33803 11322 40
33803 11328 10
33803 11332 10
33803 11333 10
33803 11334 10
33803 11335 10
33803 11336 10
33819 27659 17
33819 27671 50
33819 27672 10
33819 27673 50
33819 27674 10
33819 27676 10
33819 27677 10
33819 27679 10
33819 27681 1
33819 27691 10
33819 27696 10
33819 27706 60
33819 27716 10
33819 27717 20
33819 27718 10
33819 27719 10
33819 27720 10
34827 11264 50
34827 11266 30
34827 11267 30
34827 11274 10
34827 11276 10
34827 11277 10
34827 11278 10
34827 11279 10
34827 11287 90
34827 11288 70
34827 11289 120
34827 11290 310
34827 11291 170
34827 11292 80
34827 11293 2
34827 11295 30
34827 11296 10
34827 11297 20
34827 11298 3
34827 11299 3
34827 11300 2
34827 11301 2
34827 11302 2
34827 11307 30
34827 11308 10
34827 11312 10
34827 11313 20
34827 11315 20
34827 11319 190
34827 11322 40
34827 11328 10
34827 11332 10
34827 11333 10
34827 11334 10
34827 11335 10
34827 11336 10
34845 29707 2
34845 29719 10
34845 29723 10
34845 29730 2
34845 29731 2
34845 29732 1
34845 29733 1
34845 29734 1
34851 35851 3
34851 35869 2
34851 35874 3
34851 35876 2
34851 35877 2
34851 35878 2
34852 36875 2
34852 36893 1
34852 36898 2
34852 36899 2
34852 36901 2
34852 36902 2
34853 37899 2
34853 37917 1
34853 37922 2
34853 37923 2
34853 37924 2
34853 37926 2
34854 38923 2
34854 38941 1
34854 38946 2
34854 38947 2
34854 38948 2
34854 38949 2
35851 11264 50
35851 11266 30
35851 11267 30
35851 11274 10
35851 11276 10
35851 11277 10
35851 11278 10
35851 11279 10
35851 11287 90
35851 11288 70
35851 11289 120
35851 11290 310
35851 11291 170
35851 11292 80
35851 11293 2
35851 11295 30
35851 11296 10
35851 11297 20
35851 11298 3
35851 11299 3
35851 11300 2
35851 11301 2
35851 11302 2
35851 11307 30
35851 11308 10
35851 11312 10
35851 11313 20
35851 11315 20
35851 11319 190
35851 11322 40
35851 11328 10
35851 11332 10
35851 11333 10
35851 11334 10
35851 11335 10
35851 11336 10
35869 29707 2
35869 29719 10
35869 29723 10
35869 29730 2
35869 29731 2
35869 29732 1
35869 29733 1
35869 29734 1
35874 34827 3
35874 34845 2
35874 34851 3
35874 34852 2
35874 34853 2
35874 34854 2
35876 36875 2
35876 36893 1
35876 36898 2
35876 36899 2
35876 36901 2
35876 36902 2
35877 37899 2
35877 37917 1
35877 37922 2
35877 37923 2
35877 37924 2
35877 37926 2
35878 38923 2
35878 38941 1
35878 38946 2
35878 38947 2
35878 38948 2
35878 38949 2
36875 11264 50
36875 11266 30
36875 11267 30
36875 11274 10
36875 11276 10
36875 11277 10
36875 11278 10
36875 11279 10
36875 11287 90
36875 11288 70
36875 11289 120
36875 11290 310
36875 11291 170
36875 11292 80
36875 11293 2
36875 11295 30
36875 11296 10
36875 11297 20
36875 11298 3
36875 11299 3
36875 11300 2
36875 11301 2
36875 11302 2
36875 11307 30
36875 11308 10
36875 11312 10
36875 11313 20
36875 11315 20
36875 11319 190
36875 11322 40
36875 11328 10
36875 11332 10
36875 11333 10
36875 11334 10
36875 11335 10
36875 11336 10
36893 29707 2
36893 29719 10
36893 29723 10
36893 29730 2
36893 29731 2
36893 29732 1
36893 29733 1
36893 29734 1
36898 34827 3
36898 34845 2
36898 34851 3
36898 34852 2
36898 34853 2
36898 34854 2
36899 35851 3
36899 35869 2
36899 35874 3
36899 35876 2
36899 35877 2
36899 35878 2
36901 37899 2
36901 37917 1
36901 37922 2
36901 37923 2
36901 37924 2
36901 37926 2
36902 38923 2
36902 38941 1
36902 38946 2
36902 38947 2
36902 38948 2
36902 38949 2
37899 11264 50
37899 11266 30
37899 11267 30
37899 11274 10
37899 11276 10
37899 11277 10
37899 11278 10
37899 11279 10
37899 11287 90
37899 11288 70
37899 11289 120
37899 11290 310
37899 11291 170
37899 11292 80
37899 11293 2
37899 11295 30
37899 11296 10
37899 11297 20
37899 11298 3
37899 11299 3
37899 11300 2
37899 11301 2
37899 11302 2
37899 11307 30
37899 11308 10
37899 11312 10
37899 11313 20
37899 11315 20
37899 11319 190
37899 11322 40
37899 11328 10
37899 11332 10
37899 11333 10
37899 11334 10
37899 11335 10
37899 11336 10
37917 29707 2
37917 29719 10
37917 29723 10
37917 29730 2
37917 29731 2
37917 29732 1
37917 29733 1
37917 29734 1
37922 34827 3
37922 34845 2
37922 34851 3
37922 34852 2
37922 34853 2
37922 34854 2
37923 35851 3
37923 35869 2
37923 35874 3
37923 35876 2
37923 35877 2
37923 35878 2
37924 36875 2
37924 36893 1
37924 36898 2
37924 36899 2
37924 36901 2
37924 36902 2
37926 38923 2
37926 38941 1
37926 38946 2
37926 38947 2
37926 38948 2
37926 38949 2
38923 11264 50
38923 11266 30
38923 11267 30
38923 11274 10
38923 11276 10
38923 11277 10
38923 11278 10
38923 11279 10
38923 11287 90
38923 11288 70
38923 11289 120
38923 11290 310
38923 11291 170
38923 11292 80
38923 11293 2
38923 11295 30
38923 11296 10
38923 11297 20
38923 11298 3
38923 11299 3
38923 11300 2
38923 11301 2
38923 11302 2
38923 11307 30
38923 11308 10
38923 11312 10
38923 11313 20
38923 11315 20
38923 11319 190
38923 11322 40
38923 11328 10
38923 11332 10
38923 11333 10
38923 11334 10
38923 11335 10
38923 11336 10
38941 29707 2
38941 29719 10
38941 29723 10
38941 29730 2
38941 29731 2
38941 29732 1
38941 29733 1
38941 29734 1
38946 34827 3
38946 34845 2
38946 34851 3
38946 34852 2
38946 34853 2
38946 34854 2
38947 35851 3
38947 35869 2
38947 35874 3
38947 35876 2
38947 35877 2
38947 35878 2
38948 36875 2
38948 36893 1
38948 36898 2
38948 36899 2
38948 36901 2
38948 36902 2
38949 37899 2
38949 37917 1
38949 37922 2
38949 37923 2
38949 37924 2
38949 37926 2
39961 25611 120
39961 25623 10
39961 25624 130
39961 25626 10
39961 25627 50
39961 25639 1
39961 25640 10
39961 25641 30
39961 25642 20
39961 25648 10
39961 25655 2
39961 25668 50
39961 25669 60
39961 25670 40
39961 25671 10
39961 25675 30
39988 53287 1
39988 53299 10
39991 56331 190
39991 56336 10
39991 56345 2
39991 56346 210
39991 56359 1
39991 56361 50
39991 56368 40
39991 56369 120
39991 56371 60
39991 56374 10
39991 56376 10
39991 56377 10
39991 56378 70
39991 56379 50
39991 56381 10
39991 56382 90
39991 56383 10
39991 56384 50
39991 56385 20
40985 25611 120
40985 25623 10
40985 25624 130
40985 25626 10
40985 25627 50
40985 25639 10
40985 25640 1
40985 25641 30
40985 25642 20
40985 25648 10
40985 25655 20
40985 25668 50
40985 25669 60
40985 25670 40
40985 25671 10
40985 25675 30
42008 24587 70
42008 24599 20
42008 24601 13
42008 24602 40
42008 24603 10
42008 24617 2
42008 24618 1
42008 24626 10
42008 24644 1
42008 24645 1
42008 24646 1
42009 25611 120
42009 25623 10
42009 25624 13
42009 25626 10
42009 25627 50
42009 25639 10
42009 25640 10
42009 25641 3
42009 25642 2
42009 25648 10
42009 25655 2
42009 25668 5
42009 25669 6
42009 25670 4
42009 25671 1
42009 25675 3
42026 43032 1
42026 43033 2
42026 43049 2
42039 56331 190
42039 56336 10
42039 56345 2
42039 56346 210
42039 56359 10
42039 56361 5
42039 56368 40
42039 56369 120
42039 56371 60
42039 56374 10
42039 56376 10
42039 56377 1
42039 56378 70
42039 56379 50
42039 56381 10
42039 56382 9
42039 56383 10
42039 56384 50
42039 56385 20
42041 58409 1
42041 58416 10
42041 58423 1
42041 58426 10
42041 58427 20
42041 58429 10
42041 58430 2
42041 58431 20
42041 58432 10
42041 58433 10
42041 58435 30
42046 63529 1
42046 63536 70
42046 63543 9
42046 63545 2
42046 63546 170
42046 63547 130
42046 63548 30
42046 63549 60
42046 63551 60
42046 63552 120
42046 63553 50
42046 63554 20
42046 63564 10
42052 69643 10
42052 69656 1
42052 69657 5
42052 69659 10
42052 69673 1
42052 69680 10
42052 69701 6
42052 69702 4
42052 69703 2
42052 69707 3
42053 70667 10
42053 70680 1
42053 70681 6
42053 70683 20
42053 70697 1
42053 70704 10
42053 70724 6
42053 70726 4
42053 70727 2
42053 70731 3
42054 71691 10
42054 71704 1
42054 71705 4
42054 71707 10
42054 71721 1
42054 71738 10
42054 71748 4
42054 71749 4
42054 71751 2
42054 71755 1
42055 72715 10
42055 72729 1
42055 72731 10
42055 72745 1
42055 72752 10
42055 72772 2
42055 72773 2
42055 72774 2
42055 72779 1
42059 76825 3
42059 76841 1
42059 76848 10
42059 76868 3
42059 76869 3
42059 76870 1
42059 76871 1
43032 24587 70
43032 24599 20
43032 24601 13
43032 24602 40
43032 24603 10
43032 24617 2
43032 24618 1
43032 24626 10
43032 24644 10
43032 24645 10
43032 24646 10
43033 25611 120
43033 25623 10
43033 25624 13
43033 25626 10
43033 25627 50
43033 25639 10
43033 25640 10
43033 25641 3
43033 25642 2
43033 25648 10
43033 25655 20
43033 25668 50
43033 25669 60
43033 25670 40
43033 25671 10
43033 25675 30
43049 42008 2
43049 42009 3
43049 42026 2
43049 42039 50
43049 42041 10
43049 42046 10
43049 42052 10
43049 42053 10
43049 42054 10
43049 42055 10
43049 42059 10
44043 11264 50
44043 11266 30
44043 11267 30
44043 11274 10
44043 11276 10
44043 11277 10
44043 11278 10
44043 11279 10
44043 11287 90
44043 11288 70
44043 11289 120
44043 11290 31
44043 11291 17
44043 11292 80
44043 11293 20
44043 11295 30
44043 11296 10
44043 11297 20
44043 11298 30
44043 11299 30
44043 11300 20
44043 11301 20
44043 11302 20
44043 11307 3
44043 11308 10
44043 11312 10
44043 11313 20
44043 11315 20
44043 11319 190
44043 11322 40
44043 11328 10
44043 11332 10
44043 11333 10
44043 11334 10
44043 11335 10
44043 11336 10
44058 26635 31
44058 26640 10
44058 26648 40
44058 26649 10
44058 26651 1
44058 26667 1
44058 26673 30
44058 26675 20
44058 26678 10
44058 26679 210
44058 26696 20
44059 27659 17
44059 27671 50
44059 27672 10
44059 27673 50
44059 27674 1
44059 27676 10
44059 27677 10
44059 27679 10
44059 27681 10
44059 27691 1
44059 27696 10
44059 27706 60
44059 27716 10
44059 27717 20
44059 27718 10
44059 27719 10
44059 27720 10
45067 11264 50
45067 11266 30
45067 11267 30
45067 11274 10
45067 11276 10
45067 11277 10
45067 11278 10
45067 11279 10
45067 11287 90
45067 11288 70
45067 11289 120
45067 11290 310
45067 11291 170
45067 11292 8
45067 11293 20
45067 11295 30
45067 11296 10
45067 11297 20
45067 11298 30
45067 11299 30
45067 11300 20
45067 11301 20
45067 11302 20
45067 11307 30
45067 11308 1
45067 11312 10
45067 11313 20
45067 11315 20
45067 11319 190
45067 11322 40
45067 11328 10
45067 11332 10
45067 11333 10
45067 11334 10
45067 11335 10
45067 11336 10
45084 28683 8
45084 28699 10
45084 28716 3
45084 28717 20
46108 28683 80
46108 28699 10
46108 28716 30
46108 28717 2
47151 48174 1
47151 48176 20
48174 47151 1
48176 49163 10
48176 49177 10
48176 49179 10
48176 49199 2
48176 49207 40
48176 49209 10
48176 49210 70
48176 49211 60
48176 49212 10
48176 49213 20
48176 49214 70
48176 49215 50
48176 49216 50
48176 49217 30
48176 49218 10
48176 49220 10
48176 49221 10
48176 49223 10
48176 49225 20
48176 49226 20
48176 49227 10
48176 49228 10
49163 11264 50
49163 11266 30
49163 11267 30
49163 11274 10
49163 11276 10
49163 11277 10
49163 11278 10
49163 11279 10
49163 11287 90
49163 11288 70
49163 11289 12
49163 11290 310
49163 11291 17
49163 11292 80
49163 11293 20
49163 11295 30
49163 11296 10
49163 11297 20
49163 11298 30
49163 11299 30
49163 11300 20
49163 11301 20
49163 11302 20
49163 11307 30
49163 11308 10
49163 11312 1
49163 11313 20
49163 11315 20
49163 11319 19
49163 11322 4
49163 11328 1
49163 11332 1
49163 11333 1
49163 11334 10
49163 11335 1
49163 11336 10
49177 25611 12
49177 25623 10
49177 25624 130
49177 25626 10
49177 25627 5
49177 25639 10
49177 25640 10
49177 25641 30
49177 25642 20
49177 25648 1
49177 25655 2
49177 25668 5
49177 25669 6
49177 25670 40
49177 25671 1
49177 25675 3
49179 27659 17
49179 27671 50
49179 27672 10
49179 27673 5
49179 27674 10
49179 27676 10
49179 27677 10
49179 27679 10
49179 27681 10
49179 27691 10
49179 27696 1
49179 27706 6
49179 27716 1
49179 27717 2
49179 27718 10
49179 27719 1
49179 27720 10
49199 48174 10
49199 48176 2
49207 56331 19
49207 56336 10
49207 56345 2
49207 56346 210
49207 56359 10
49207 56361 50
49207 56368 4
49207 56369 120
49207 56371 60
49207 56374 10
49207 56376 10
49207 56377 1
49207 56378 7
49207 56379 5
49207 56381 1
49207 56382 9
49207 56383 1
49207 56384 5
49207 56385 2
49209 58409 10
49209 58416 1
49209 58423 1
49209 58426 1
49209 58427 2
49209 58429 1
49209 58430 2
49209 58431 2
49209 58432 1
49209 58433 1
49209 58435 30
49210 59403 4
49210 59419 6
49210 59440 7
49210 59447 7
49210 59449 1
49210 59451 15
49210 59452 4
49210 59453 6
49210 59454 17
49210 59455 4
49210 59456 10
49210 59457 5
49210 59458 3
49210 59462 10
49210 59468 1
49211 60464 6
49211 60471 5
49211 60473 2
49211 60474 15
49211 60476 2
49211 60477 5
49211 60478 13
49211 60479 5
49211 60480 9
49211 60481 5
49211 60482 1
49212 61488 1
49212 61498 4
49212 61499 2
49212 61501 2
49212 61502 3
49212 61503 2
49212 61504 2
49212 61505 2
49212 61506 1
49213 62512 2
49213 62519 1
49213 62521 1
49213 62522 6
49213 62523 5
49213 62524 2
49213 62526 6
49213 62527 3
49213 62528 6
49213 62529 5
49213 62530 1
49214 63529 10
49214 63536 7
49214 63543 9
49214 63545 2
49214 63546 17
49214 63547 13
49214 63548 3
49214 63549 6
49214 63551 6
49214 63552 12
49214 63553 5
49214 63554 2
49214 63564 1
49215 64560 5
49215 64567 1
49215 64569 2
49215 64570 4
49215 64571 5
49215 64572 2
49215 64573 3
49215 64574 6
49215 64576 4
49215 64577 5
49215 64578 1
49215 64588 1
49216 65547 1
49216 65584 5
49216 65591 5
49216 65593 1
49216 65594 10
49216 65595 9
49216 65596 2
49216 65597 6
49216 65598 12
49216 65599 4
49216 65601 7
49216 65602 3
49216 65612 1
49217 66608 3
49217 66615 2
49217 66617 1
49217 66618 5
49217 66619 5
49217 66620 2
49217 66621 5
49217 66622 5
49217 66623 5
49217 66624 7
49217 66626 2
49217 66636 1
49218 67632 1
49218 67642 3
49218 67643 1
49218 67644 1
49218 67645 1
49218 67646 2
49218 67647 1
49218 67648 3
49218 67649 2
49218 67660 1
49220 69643 1
49220 69656 10
49220 69657 5
49220 69659 1
49220 69673 10
49220 69680 1
49220 69701 6
49220 69702 40
49220 69703 2
49220 69707 3
49221 70667 1
49221 70680 10
49221 70681 6
49221 70683 2
49221 70697 10
49221 70704 1
49221 70724 6
49221 70726 40
49221 70727 2
49221 70731 3
49223 72715 1
49223 72729 1
49223 72731 1
49223 72745 10
49223 72752 1
49223 72772 2
49223 72773 2
49223 72774 20
49223 72779 1
49225 74800 2
49225 74826 3
49226 75824 2
49226 75849 3
49227 76825 3
49227 76841 10
49227 76848 1
49227 76868 3
49227 76869 3
49227 76870 10
49227 76871 1
49228 77872 1
49228 77882 1
49228 77886 1
49228 77887 1
49228 77888 1
49228 77889 1
49228 77890 1
50187 11264 50
50187 11266 30
50187 11267 30
50187 11274 10
50187 11276 10
50187 11277 10
50187 11278 10
50187 11279 10
50187 11287 90
50187 11288 70
50187 11289 120
50187 11290 31
50187 11291 170
50187 11292 80
50187 11293 20
50187 11295 30
50187 11296 10
50187 11297 20
50187 11298 30
50187 11299 30
50187 11300 20
50187 11301 20
50187 11302 20
50187 11307 30
50187 11308 10
50187 11312 10
50187 11313 2
50187 11315 2
50187 11319 19
50187 11322 40
50187 11328 10
50187 11332 10
50187 11333 10
50187 11334 10
50187 11335 10
50187 11336 10
50202 26635 31
50202 26640 10
50202 26648 40
50202 26649 10
50202 26651 10
50202 26667 10
50202 26673 3
50202 26675 2
50202 26678 1
50202 26679 21
50202 26696 20
50226 51224 10
50226 51249 1
50227 52235 2
50227 52250 2
50227 52273 9
50227 52276 10
50227 52277 10
50227 52278 2
50227 52279 6
50230 55322 1
50230 55345 1
50230 55347 2
50230 55351 1
50231 56331 19
50231 56336 10
50231 56345 20
50231 56346 21
50231 56359 10
50231 56361 50
50231 56368 40
50231 56369 12
50231 56371 6
50231 56374 1
50231 56376 1
50231 56377 10
50231 56378 70
50231 56379 50
50231 56381 10
50231 56382 90
50231 56383 10
50231 56384 50
50231 56385 20
50232 57393 1
50232 57399 1
51224 24587 70
51224 24599 20
51224 24601 130
51224 24602 40
51224 24603 10
51224 24617 20
51224 24618 10
51224 24626 1
51224 24644 10
51224 24645 10
51224 24646 10
51249 50187 20
51249 50202 30
51249 50226 1
51249 50227 90
51249 50230 10
51249 50231 120
51249 50232 10
52235 11264 50
52235 11266 30
52235 11267 30
52235 11274 10
52235 11276 10
52235 11277 10
52235 11278 10
52235 11279 10
52235 11287 90
52235 11288 70
52235 11289 120
52235 11290 31
52235 11291 170
52235 11292 80
52235 11293 20
52235 11295 30
52235 11296 10
52235 11297 20
52235 11298 30
52235 11299 30
52235 11300 20
52235 11301 20
52235 11302 20
52235 11307 30
52235 11308 10
52235 11312 10
52235 11313 2
52235 11315 2
52235 11319 19
52235 11322 40
52235 11328 10
52235 11332 10
52235 11333 10
52235 11334 10
52235 11335 10
52235 11336 10
52250 26635 31
52250 26640 10
52250 26648 40
52250 26649 10
52250 26651 10
52250 26667 10
52250 26673 3
52250 26675 2
52250 26678 1
52250 26679 21
52250 26696 20
52273 50187 2
52273 50202 3
52273 50226 10
52273 50227 9
52273 50230 1
52273 50231 12
52273 50232 10
52276 53287 10
52276 53299 1
52277 54323 1
52278 55322 1
52278 55345 1
52278 55347 2
52278 55351 1
52279 56331 19
52279 56336 10
52279 56345 20
52279 56346 21
52279 56359 10
52279 56361 50
52279 56368 40
52279 56369 12
52279 56371 6
52279 56374 1
52279 56376 10
52279 56377 10
52279 56378 70
52279 56379 50
52279 56381 10
52279 56382 90
52279 56383 10
52279 56384 50
52279 56385 20
53287 39961 10
53287 39988 1
53287 39991 10
53299 52235 20
53299 52250 20
53299 52273 90
53299 52276 1
53299 52277 10
53299 52278 20
53299 52279 60
54323 52235 20
54323 52250 20
54323 52273 90
54323 52276 10
54323 52277 1
54323 52278 20
54323 52279 60
55322 26635 310
55322 26640 10
55322 26648 40
55322 26649 10
55322 26651 10
55322 26667 10
55322 26673 3
55322 26675 2
55322 26678 1
55322 26679 21
55322 26696 20
55345 50187 20
55345 50202 3
55345 50226 10
55345 50227 9
55345 50230 1
55345 50231 12
55345 50232 10
55347 52235 20
55347 52250 2
55347 52273 9
55347 52276 10
55347 52277 10
55347 52278 2
55347 52279 6
55351 56331 190
55351 56336 10
55351 56345 20
55351 56346 21
55351 56359 10
55351 56361 50
55351 56368 40
55351 56369 12
55351 56371 6
55351 56374 1
55351 56376 10
55351 56377 10
55351 56378 70
55351 56379 50
55351 56381 10
55351 56382 90
55351 56383 10
55351 56384 50
55351 56385 20
56331 11264 50
56331 11266 30
56331 11267 30
56331 11274 10
56331 11276 10
56331 11277 10
56331 11278 10
56331 11279 10
56331 11287 90
56331 11288 70
56331 11289 12
56331 11290 31
56331 11291 170
56331 11292 80
56331 11293 20
56331 11295 30
56331 11296 10
56331 11297 20
56331 11298 30
56331 11299 30
56331 11300 20
56331 11301 20
56331 11302 20
56331 11307 30
56331 11308 10
56331 11312 1
56331 11313 2
56331 11315 2
56331 11319 19
56331 11322 4
56331 11328 1
56331 11332 10
56331 11333 10
56331 11334 10
56331 11335 10
56331 11336 10
56336 16401 40
56336 16402 40
56336 16403 40
56336 16404 30
56336 16405 30
56336 16406 30
56336 16407 30
56336 16410 1
56336 16439 1
56345 25611 12
56345 25623 10
56345 25624 130
56345 25626 1
56345 25627 50
56345 25639 1
56345 25640 10
56345 25641 3
56345 25642 20
56345 25648 1
56345 25655 2
56345 25668 50
56345 25669 60
56345 25670 40
56345 25671 10
56345 25675 30
56346 26635 31
56346 26640 1
56346 26648 40
56346 26649 1
56346 26651 10
56346 26667 10
56346 26673 3
56346 26675 2
56346 26678 1
56346 26679 21
56346 26696 20
56359 39961 1
56359 39988 10
56359 39991 1
56361 42008 20
56361 42009 3
56361 42026 20
56361 42039 5
56361 42041 1
56361 42046 1
56361 42052 10
56361 42053 10
56361 42054 10
56361 42055 10
56361 42059 10
56368 49163 1
56368 49177 1
56368 49179 10
56368 49199 20
56368 49207 4
56368 49209 1
56368 49210 7
56368 49211 6
56368 49212 10
56368 49213 2
56368 49214 7
56368 49215 5
56368 49216 5
56368 49217 3
56368 49218 10
56368 49220 10
56368 49221 10
56368 49223 10
56368 49225 20
56368 49226 20
56368 49227 10
56368 49228 10
56369 50187 2
56369 50202 3
56369 50226 10
56369 50227 9
56369 50230 1
56369 50231 12
56369 50232 1
56371 52235 2
56371 52250 2
56371 52273 9
56371 52276 10
56371 52277 10
56371 52278 2
56371 52279 6
56374 55322 1
56374 55345 1
56374 55347 2
56374 55351 1
56376 57393 1
56376 57399 1
56377 58409 1
56377 58416 1
56377 58423 1
56377 58426 1
56377 58427 2
56377 58429 1
56377 58430 2
56377 58431 2
56377 58432 1
56377 58433 1
56377 58435 30
56378 59403 4
56378 59419 60
56378 59440 7
56378 59447 7
56378 59449 1
56378 59451 15
56378 59452 40
56378 59453 6
56378 59454 17
56378 59455 4
56378 59456 10
56378 59457 5
56378 59458 30
56378 59462 10
56378 59468 10
56379 60464 6
56379 60471 5
56379 60473 2
56379 60474 15
56379 60476 20
56379 60477 5
56379 60478 13
56379 60479 5
56379 60480 9
56379 60481 5
56379 60482 10
56381 62512 2
56381 62519 1
56381 62521 1
56381 62522 6
56381 62523 5
56381 62524 20
56381 62526 6
56381 62527 3
56381 62528 6
56381 62529 5
56381 62530 10
56382 63529 1
56382 63536 7
56382 63543 9
56382 63545 2
56382 63546 17
56382 63547 13
56382 63548 30
56382 63549 6
56382 63551 6
56382 63552 12
56382 63553 5
56382 63554 20
56382 63564 10
56383 64560 5
56383 64567 1
56383 64569 2
56383 64570 4
56383 64571 5
56383 64572 20
56383 64573 3
56383 64574 6
56383 64576 4
56383 64577 5
56383 64578 10
56383 64588 10
56384 65547 1
56384 65584 5
56384 65591 5
56384 65593 1
56384 65594 10
56384 65595 9
56384 65596 20
56384 65597 6
56384 65598 12
56384 65599 4
56384 65601 7
56384 65602 30
56384 65612 10
56385 66608 3
56385 66615 2
56385 66617 1
56385 66618 5
56385 66619 5
56385 66620 20
56385 66621 5
56385 66622 5
56385 66623 5
56385 66624 7
56385 66626 20
56385 66636 10
57393 50187 20
57393 50202 30
57393 50226 10
57393 50227 90
57393 50230 10
57393 50231 12
57393 50232 1
57399 56331 190
57399 56336 10
57399 56345 20
57399 56346 210
57399 56359 10
57399 56361 50
57399 56368 40
57399 56369 12
57399 56371 60
57399 56374 10
57399 56376 1
57399 56377 10
57399 56378 70
57399 56379 50
57399 56381 10
57399 56382 90
57399 56383 10
57399 56384 50
57399 56385 20
58409 42008 20
58409 42009 30
58409 42026 20
58409 42039 5
58409 42041 1
58409 42046 1
58409 42052 10
58409 42053 10
58409 42054 10
58409 42055 10
58409 42059 10
58416 49163 10
58416 49177 10
58416 49179 10
58416 49199 20
58416 49207 4
58416 49209 1
58416 49210 7
58416 49211 6
58416 49212 10
58416 49213 2
58416 49214 7
58416 49215 5
58416 49216 5
58416 49217 3
58416 49218 10
58416 49220 10
58416 49221 10
58416 49223 10
58416 49225 20
58416 49226 20
58416 49227 10
58416 49228 10
58423 56331 190
58423 56336 10
58423 56345 20
58423 56346 210
58423 56359 10
58423 56361 5
58423 56368 4
58423 56369 120
58423 56371 60
58423 56374 10
58423 56376 10
58423 56377 1
58423 56378 7
58423 56379 5
58423 56381 1
58423 56382 9
58423 56383 1
58423 56384 5
58423 56385 2
58426 59403 40
58426 59419 60
58426 59440 7
58426 59447 7
58426 59449 1
58426 59451 15
58426 59452 40
58426 59453 6
58426 59454 17
58426 59455 4
58426 59456 10
58426 59457 5
58426 59458 30
58426 59462 10
58426 59468 10
58427 60464 6
58427 60471 5
58427 60473 2
58427 60474 15
58427 60476 20
58427 60477 5
58427 60478 13
58427 60479 5
58427 60480 9
58427 60481 5
58427 60482 10
58429 62512 2
58429 62519 1
58429 62521 1
58429 62522 6
58429 62523 5
58429 62524 20
58429 62526 6
58429 62527 3
58429 62528 6
58429 62529 5
58429 62530 10
58430 63529 1
58430 63536 7
58430 63543 9
58430 63545 2
58430 63546 17
58430 63547 13
58430 63548 30
58430 63549 6
58430 63551 6
58430 63552 12
58430 63553 5
58430 63554 20
58430 63564 10
58431 64560 5
58431 64567 1
58431 64569 2
58431 64570 4
58431 64571 5
58431 64572 20
58431 64573 3
58431 64574 6
58431 64576 4
58431 64577 5
58431 64578 10
58431 64588 10
58432 65547 10
58432 65584 5
58432 65591 5
58432 65593 1
58432 65594 10
58432 65595 9
58432 65596 20
58432 65597 6
58432 65598 12
58432 65599 4
58432 65601 7
58432 65602 30
58432 65612 10
58433 66608 3
58433 66615 2
58433 66617 1
58433 66618 5
58433 66619 5
58433 66620 20
58433 66621 5
58433 66622 5
58433 66623 5
58433 66624 7
58433 66626 20
58433 66636 10
58435 68665 3
59403 11264 50
59403 11266 30
59403 11267 30
59403 11274 10
59403 11276 10
59403 11277 10
59403 11278 10
59403 11279 10
59403 11287 90
59403 11288 70
59403 11289 120
59403 11290 310
59403 11291 17
59403 11292 80
59403 11293 20
59403 11295 30
59403 11296 10
59403 11297 20
59403 11298 30
59403 11299 30
59403 11300 20
59403 11301 20
59403 11302 20
59403 11307 30
59403 11308 10
59403 11312 1
59403 11313 20
59403 11315 20
59403 11319 19
59403 11322 4
59403 11328 1
59403 11332 10
59403 11333 10
59403 11334 1
59403 11335 10
59403 11336 10
59419 27659 17
59419 27671 50
59419 27672 10
59419 27673 50
59419 27674 10
59419 27676 10
59419 27677 10
59419 27679 10
59419 27681 10
59419 27691 10
59419 27696 1
59419 27706 6
59419 27716 10
59419 27717 20
59419 27718 1
59419 27719 10
59419 27720 10
59440 49163 1
59440 49177 10
59440 49179 1
59440 49199 20
59440 49207 4
59440 49209 1
59440 49210 7
59440 49211 6
59440 49212 1
59440 49213 2
59440 49214 7
59440 49215 5
59440 49216 5
59440 49217 3
59440 49218 1
59440 49220 10
59440 49221 10
59440 49223 10
59440 49225 20
59440 49226 20
59440 49227 10
59440 49228 1
59447 56331 19
59447 56336 10
59447 56345 20
59447 56346 210
59447 56359 10
59447 56361 50
59447 56368 4
59447 56369 120
59447 56371 60
59447 56374 10
59447 56376 10
59447 56377 1
59447 56378 7
59447 56379 5
59447 56381 1
59447 56382 9
59447 56383 1
59447 56384 5
59447 56385 2
59449 58409 10
59449 58416 1
59449 58423 1
59449 58426 1
59449 58427 2
59449 58429 1
59449 58430 2
59449 58431 2
59449 58432 1
59449 58433 1
59449 58435 30
59451 60464 6
59451 60471 5
59451 60473 2
59451 60474 15
59451 60476 2
59451 60477 5
59451 60478 13
59451 60479 5
59451 60480 9
59451 60481 5
59451 60482 1
59452 61488 1
59452 61498 4
59452 61499 2
59452 61501 2
59452 61502 3
59452 61503 2
59452 61504 2
59452 61505 2
59452 61506 1
59453 62512 2
59453 62519 1
59453 62521 1
59453 62522 6
59453 62523 5
59453 62524 2
59453 62526 6
59453 62527 3
59453 62528 6
59453 62529 5
59453 62530 1
59454 63529 10
59454 63536 7
59454 63543 9
59454 63545 2
59454 63546 17
59454 63547 13
59454 63548 3
59454 63549 6
59454 63551 6
59454 63552 12
59454 63553 5
59454 63554 2
59454 63564 1
59455 64560 5
59455 64567 1
59455 64569 2
59455 64570 4
59455 64571 5
59455 64572 2
59455 64573 3
59455 64574 6
59455 64576 4
59455 64577 5
59455 64578 1
59455 64588 1
59456 65547 1
59456 65584 5
59456 65591 5
59456 65593 1
59456 65594 10
59456 65595 9
59456 65596 2
59456 65597 6
59456 65598 12
59456 65599 4
59456 65601 7
59456 65602 3
59456 65612 1
59457 66608 3
59457 66615 2
59457 66617 1
59457 66618 5
59457 66619 5
59457 66620 2
59457 66621 5
59457 66622 5
59457 66623 5
59457 66624 7
59457 66626 2
59457 66636 1
59458 67632 1
59458 67642 3
59458 67643 1
59458 67644 1
59458 67645 1
59458 67646 2
59458 67647 1
59458 67648 3
59458 67649 2
59458 67660 1
59462 71691 1
59462 71704 10
59462 71705 40
59462 71707 1
59462 71721 10
59462 71738 1
59462 71748 40
59462 71749 40
59462 71751 20
59462 71755 10
59468 77872 1
59468 77882 1
59468 77886 1
59468 77887 1
59468 77888 1
59468 77889 1
59468 77890 1
60464 49163 10
60464 49177 10
60464 49179 10
60464 49199 20
60464 49207 4
60464 49209 1
60464 49210 7
60464 49211 6
60464 49212 1
60464 49213 2
60464 49214 7
60464 49215 5
60464 49216 5
60464 49217 3
60464 49218 1
60464 49220 10
60464 49221 10
60464 49223 10
60464 49225 20
60464 49226 20
60464 49227 10
60464 49228 10
60471 56331 190
60471 56336 10
60471 56345 20
60471 56346 210
60471 56359 10
60471 56361 50
60471 56368 4
60471 56369 120
60471 56371 60
60471 56374 10
60471 56376 10
60471 56377 1
60471 56378 7
60471 56379 5
60471 56381 1
60471 56382 9
60471 56383 1
60471 56384 5
60471 56385 2
60473 58409 10
60473 58416 1
60473 58423 1
60473 58426 1
60473 58427 2
60473 58429 1
60473 58430 2
60473 58431 2
60473 58432 1
60473 58433 1
60473 58435 30
60474 59403 40
60474 59419 60
60474 59440 7
60474 59447 7
60474 59449 1
60474 59451 15
60474 59452 4
60474 59453 6
60474 59454 17
60474 59455 4
60474 59456 10
60474 59457 5
60474 59458 3
60474 59462 10
60474 59468 10
60476 61488 1
60476 61498 4
60476 61499 2
60476 61501 2
60476 61502 3
60476 61503 2
60476 61504 2
60476 61505 2
60476 61506 1
60477 62512 2
60477 62519 1
60477 62521 1
60477 62522 6
60477 62523 5
60477 62524 2
60477 62526 6
60477 62527 3
60477 62528 6
60477 62529 5
60477 62530 1
60478 63529 10
60478 63536 7
60478 63543 9
60478 63545 2
60478 63546 17
60478 63547 13
60478 63548 3
60478 63549 6
60478 63551 6
60478 63552 12
60478 63553 5
60478 63554 2
60478 63564 10
60479 64560 5
60479 64567 1
60479 64569 2
60479 64570 4
60479 64571 5
60479 64572 2
60479 64573 3
60479 64574 6
60479 64576 4
60479 64577 5
60479 64578 1
60479 64588 10
60480 65547 10
60480 65584 5
60480 65591 5
60480 65593 1
60480 65594 10
60480 65595 9
60480 65596 2
60480 65597 6
60480 65598 12
60480 65599 4
60480 65601 7
60480 65602 3
60480 65612 10
60481 66608 3
60481 66615 2
60481 66617 1
60481 66618 5
60481 66619 5
60481 66620 2
60481 66621 5
60481 66622 5
60481 66623 5
60481 66624 7
60481 66626 2
60481 66636 10
60482 67632 1
60482 67642 3
60482 67643 1
60482 67644 1
60482 67645 1
60482 67646 2
60482 67647 1
60482 67648 3
60482 67649 2
60482 67660 10
61488 49163 10
61488 49177 10
61488 49179 10
61488 49199 20
61488 49207 40
61488 49209 10
61488 49210 7
61488 49211 6
61488 49212 1
61488 49213 2
61488 49214 7
61488 49215 5
61488 49216 5
61488 49217 3
61488 49218 1
61488 49220 10
61488 49221 10
61488 49223 10
61488 49225 20
61488 49226 20
61488 49227 10
61488 49228 10
61498 59403 40
61498 59419 60
61498 59440 7
61498 59447 70
61498 59449 10
61498 59451 15
61498 59452 4
61498 59453 6
61498 59454 17
61498 59455 4
61498 59456 10
61498 59457 5
61498 59458 3
61498 59462 10
61498 59468 10
61499 60464 6
61499 60471 50
61499 60473 20
61499 60474 15
61499 60476 2
61499 60477 5
61499 60478 13
61499 60479 5
61499 60480 9
61499 60481 5
61499 60482 1
61501 62512 2
61501 62519 10
61501 62521 10
61501 62522 6
61501 62523 5
61501 62524 2
61501 62526 6
61501 62527 3
61501 62528 6
61501 62529 5
61501 62530 1
61502 63529 10
61502 63536 7
61502 63543 90
61502 63545 20
61502 63546 17
61502 63547 13
61502 63548 3
61502 63549 6
61502 63551 6
61502 63552 12
61502 63553 5
61502 63554 2
61502 63564 10
61503 64560 5
61503 64567 10
61503 64569 20
61503 64570 4
61503 64571 5
61503 64572 2
61503 64573 3
61503 64574 6
61503 64576 4
61503 64577 5
61503 64578 1
61503 64588 10
61504 65547 10
61504 65584 5
61504 65591 50
61504 65593 10
61504 65594 10
61504 65595 9
61504 65596 2
61504 65597 6
61504 65598 12
61504 65599 4
61504 65601 7
61504 65602 3
61504 65612 10
61505 66608 3
61505 66615 20
61505 66617 10
61505 66618 5
61505 66619 5
61505 66620 2
61505 66621 5
61505 66622 5
61505 66623 5
61505 66624 7
61505 66626 2
61505 66636 10
61506 67632 1
61506 67642 3
61506 67643 1
61506 67644 1
61506 67645 1
61506 67646 2
61506 67647 1
61506 67648 3
61506 67649 2
61506 67660 10
62512 49163 10
62512 49177 10
62512 49179 10
62512 49199 20
62512 49207 4
62512 49209 1
62512 49210 7
62512 49211 6
62512 49212 1
62512 49213 2
62512 49214 7
62512 49215 5
62512 49216 5
62512 49217 3
62512 49218 1
62512 49220 10
62512 49221 10
62512 49223 10
62512 49225 20
62512 49226 20
62512 49227 10
62512 49228 10
62519 56331 190
62519 56336 10
62519 56345 20
62519 56346 210
62519 56359 10
62519 56361 50
62519 56368 4
62519 56369 120
62519 56371 60
62519 56374 10
62519 56376 10
62519 56377 1
62519 56378 7
62519 56379 5
62519 56381 1
62519 56382 9
62519 56383 1
62519 56384 5
62519 56385 2
62521 58409 10
62521 58416 1
62521 58423 1
62521 58426 1
62521 58427 2
62521 58429 1
62521 58430 2
62521 58431 2
62521 58432 1
62521 58433 1
62521 58435 30
62522 59403 40
62522 59419 60
62522 59440 7
62522 59447 7
62522 59449 1
62522 59451 15
62522 59452 4
62522 59453 6
62522 59454 17
62522 59455 4
62522 59456 10
62522 59457 5
62522 59458 3
62522 59462 10
62522 59468 10
62523 60464 6
62523 60471 5
62523 60473 2
62523 60474 15
62523 60476 2
62523 60477 5
62523 60478 13
62523 60479 5
62523 60480 9
62523 60481 5
62523 60482 1
62524 61488 1
62524 61498 4
62524 61499 2
62524 61501 2
62524 61502 3
62524 61503 2
62524 61504 2
62524 61505 2
62524 61506 1
62526 63529 10
62526 63536 7
62526 63543 9
62526 63545 2
62526 63546 17
62526 63547 13
62526 63548 3
62526 63549 6
62526 63551 6
62526 63552 12
62526 63553 5
62526 63554 2
62526 63564 10
62527 64560 5
62527 64567 1
62527 64569 2
62527 64570 4
62527 64571 5
62527 64572 2
62527 64573 3
62527 64574 6
62527 64576 4
62527 64577 5
62527 64578 1
62527 64588 10
62528 65547 10
62528 65584 5
62528 65591 5
62528 65593 1
62528 65594 10
62528 65595 9
62528 65596 2
62528 65597 6
62528 65598 12
62528 65599 4
62528 65601 7
62528 65602 3
62528 65612 10
62529 66608 3
62529 66615 2
62529 66617 1
62529 66618 5
62529 66619 5
62529 66620 2
62529 66621 5
62529 66622 5
62529 66623 5
62529 66624 7
62529 66626 2
62529 66636 10
62530 67632 1
62530 67642 3
62530 67643 1
62530 67644 1
62530 67645 1
62530 67646 2
62530 67647 1
62530 67648 3
62530 67649 2
62530 67660 10
63529 42008 20
63529 42009 30
63529 42026 20
63529 42039 5
63529 42041 1
63529 42046 1
63529 42052 10
63529 42053 10
63529 42054 10
63529 42055 10
63529 42059 10
63536 49163 10
63536 49177 10
63536 49179 10
63536 49199 20
63536 49207 4
63536 49209 1
63536 49210 7
63536 49211 6
63536 49212 1
63536 49213 2
63536 49214 7
63536 49215 5
63536 49216 5
63536 49217 3
63536 49218 1
63536 49220 10
63536 49221 10
63536 49223 10
63536 49225 20
63536 49226 20
63536 49227 10
63536 49228 1
63543 56331 190
63543 56336 10
63543 56345 20
63543 56346 210
63543 56359 10
63543 56361 5
63543 56368 4
63543 56369 120
63543 56371 60
63543 56374 10
63543 56376 10
63543 56377 1
63543 56378 7
63543 56379 5
63543 56381 1
63543 56382 9
63543 56383 1
63543 56384 5
63543 56385 2
63545 58409 1
63545 58416 1
63545 58423 1
63545 58426 1
63545 58427 2
63545 58429 1
63545 58430 2
63545 58431 2
63545 58432 1
63545 58433 1
63545 58435 30
63546 59403 40
63546 59419 60
63546 59440 7
63546 59447 7
63546 59449 1
63546 59451 15
63546 59452 4
63546 59453 6
63546 59454 17
63546 59455 4
63546 59456 10
63546 59457 5
63546 59458 3
63546 59462 10
63546 59468 1
63547 60464 6
63547 60471 5
63547 60473 2
63547 60474 15
63547 60476 2
63547 60477 5
63547 60478 13
63547 60479 5
63547 60480 9
63547 60481 5
63547 60482 1
63548 61488 1
63548 61498 4
63548 61499 2
63548 61501 2
63548 61502 3
63548 61503 2
63548 61504 2
63548 61505 2
63548 61506 1
63549 62512 2
63549 62519 1
63549 62521 1
63549 62522 6
63549 62523 5
63549 62524 2
63549 62526 6
63549 62527 3
63549 62528 6
63549 62529 5
63549 62530 1
63551 64560 5
63551 64567 1
63551 64569 2
63551 64570 4
63551 64571 5
63551 64572 2
63551 64573 3
63551 64574 6
63551 64576 4
63551 64577 5
63551 64578 1
63551 64588 1
63552 65547 10
63552 65584 5
63552 65591 5
63552 65593 1
63552 65594 10
63552 65595 9
63552 65596 2
63552 65597 6
63552 65598 12
63552 65599 4
63552 65601 7
63552 65602 3
63552 65612 1
63553 66608 3
63553 66615 2
63553 66617 1
63553 66618 5
63553 66619 5
63553 66620 2
63553 66621 5
63553 66622 5
63553 66623 5
63553 66624 7
63553 66626 2
63553 66636 1
63554 67632 1
63554 67642 3
63554 67643 1
63554 67644 1
63554 67645 1
63554 67646 2
63554 67647 1
63554 67648 3
63554 67649 2
63554 67660 1
63564 77872 1
63564 77882 1
63564 77886 1
63564 77887 1
63564 77888 1
63564 77889 1
63564 77890 1
64560 49163 10
64560 49177 10
64560 49179 10
64560 49199 20
64560 49207 4
64560 49209 1
64560 49210 7
64560 49211 6
64560 49212 1
64560 49213 2
64560 49214 7
64560 49215 5
64560 49216 5
64560 49217 3
64560 49218 1
64560 49220 10
64560 49221 10
64560 49223 10
64560 49225 20
64560 49226 20
64560 49227 10
64560 49228 1
64567 56331 190
64567 56336 10
64567 56345 20
64567 56346 210
64567 56359 10
64567 56361 50
64567 56368 4
64567 56369 120
64567 56371 60
64567 56374 10
64567 56376 10
64567 56377 1
64567 56378 7
64567 56379 5
64567 56381 1
64567 56382 9
64567 56383 1
64567 56384 5
64567 56385 2
64569 58409 10
64569 58416 1
64569 58423 1
64569 58426 1
64569 58427 2
64569 58429 1
64569 58430 2
64569 58431 2
64569 58432 1
64569 58433 1
64569 58435 30
64570 59403 40
64570 59419 60
64570 59440 7
64570 59447 7
64570 59449 1
64570 59451 15
64570 59452 4
64570 59453 6
64570 59454 17
64570 59455 4
64570 59456 10
64570 59457 5
64570 59458 3
64570 59462 10
64570 59468 1
64571 60464 6
64571 60471 5
64571 60473 2
64571 60474 15
64571 60476 2
64571 60477 5
64571 60478 13
64571 60479 5
64571 60480 9
64571 60481 5
64571 60482 1
64572 61488 1
64572 61498 4
64572 61499 2
64572 61501 2
64572 61502 3
64572 61503 2
64572 61504 2
64572 61505 2
64572 61506 1
64573 62512 2
64573 62519 1
64573 62521 1
64573 62522 6
64573 62523 5
64573 62524 2
64573 62526 6
64573 62527 3
64573 62528 6
64573 62529 5
64573 62530 1
64574 63529 10
64574 63536 7
64574 63543 9
64574 63545 2
64574 63546 17
64574 63547 13
64574 63548 3
64574 63549 6
64574 63551 6
64574 63552 12
64574 63553 5
64574 63554 2
64574 63564 1
64576 65547 10
64576 65584 5
64576 65591 5
64576 65593 1
64576 65594 10
64576 65595 9
64576 65596 2
64576 65597 6
64576 65598 12
64576 65599 4
64576 65601 7
64576 65602 3
64576 65612 1
64577 66608 3
64577 66615 2
64577 66617 1
64577 66618 5
64577 66619 5
64577 66620 2
64577 66621 5
64577 66622 5
64577 66623 5
64577 66624 7
64577 66626 2
64577 66636 1
64578 67632 1
64578 67642 3
64578 67643 1
64578 67644 1
64578 67645 1
64578 67646 2
64578 67647 1
64578 67648 3
64578 67649 2
64578 67660 1
64588 77872 1
64588 77882 1
64588 77886 1
64588 77887 1
64588 77888 1
64588 77889 1
64588 77890 1
65547 11264 50
65547 11266 30
65547 11267 30
65547 11274 10
65547 11276 10
65547 11277 10
65547 11278 10
65547 11279 10
65547 11287 90
65547 11288 70
65547 11289 120
65547 11290 310
65547 11291 170
65547 11292 80
65547 11293 20
65547 11295 30
65547 11296 10
65547 11297 20
65547 11298 30
65547 11299 30
65547 11300 20
65547 11301 20
65547 11302 20
65547 11307 30
65547 11308 10
65547 11312 1
65547 11313 20
65547 11315 20
65547 11319 19
65547 11322 4
65547 11328 1
65547 11332 10
65547 11333 10
65547 11334 10
65547 11335 10
65547 11336 10
65584 49163 1
65584 49177 10
65584 49179 10
65584 49199 20
65584 49207 4
65584 49209 1
65584 49210 7
65584 49211 6
65584 49212 1
65584 49213 2
65584 49214 7
65584 49215 5
65584 49216 5
65584 49217 3
65584 49218 1
65584 49220 10
65584 49221 10
65584 49223 10
65584 49225 20
65584 49226 20
65584 49227 10
65584 49228 1
65591 56331 19
65591 56336 10
65591 56345 20
65591 56346 210
65591 56359 10
65591 56361 50
65591 56368 4
65591 56369 120
65591 56371 60
65591 56374 10
65591 56376 10
65591 56377 1
65591 56378 7
65591 56379 5
65591 56381 1
65591 56382 9
65591 56383 1
65591 56384 5
65591 56385 2
65593 58409 10
65593 58416 1
65593 58423 1
65593 58426 1
65593 58427 2
65593 58429 1
65593 58430 2
65593 58431 2
65593 58432 1
65593 58433 1
65593 58435 30
65594 59403 4
65594 59419 60
65594 59440 7
65594 59447 7
65594 59449 1
65594 59451 15
65594 59452 4
65594 59453 6
65594 59454 17
65594 59455 4
65594 59456 10
65594 59457 5
65594 59458 3
65594 59462 10
65594 59468 1
65595 60464 6
65595 60471 5
65595 60473 2
65595 60474 15
65595 60476 2
65595 60477 5
65595 60478 13
65595 60479 5
65595 60480 9
65595 60481 5
65595 60482 1
65596 61488 1
65596 61498 4
65596 61499 2
65596 61501 2
65596 61502 3
65596 61503 2
65596 61504 2
65596 61505 2
65596 61506 1
65597 62512 2
65597 62519 1
65597 62521 1
65597 62522 6
65597 62523 5
65597 62524 2
65597 62526 6
65597 62527 3
65597 62528 6
65597 62529 5
65597 62530 1
65598 63529 10
65598 63536 7
65598 63543 9
65598 63545 2
65598 63546 17
65598 63547 13
65598 63548 3
65598 63549 6
65598 63551 6
65598 63552 12
65598 63553 5
65598 63554 2
65598 63564 1
65599 64560 5
65599 64567 1
65599 64569 2
65599 64570 4
65599 64571 5
65599 64572 2
65599 64573 3
65599 64574 6
65599 64576 4
65599 64577 5
65599 64578 1
65599 64588 1
65601 66608 3
65601 66615 2
65601 66617 1
65601 66618 5
65601 66619 5
65601 66620 2
65601 66621 5
65601 66622 5
65601 66623 5
65601 66624 7
65601 66626 2
65601 66636 1
65602 67632 1
65602 67642 3
65602 67643 1
65602 67644 1
65602 67645 1
65602 67646 2
65602 67647 1
65602 67648 3
65602 67649 2
65602 67660 1
65612 77872 1
65612 77882 1
65612 77886 1
65612 77887 1
65612 77888 1
65612 77889 1
65612 77890 1
66608 49163 10
66608 49177 10
66608 49179 10
66608 49199 20
66608 49207 4
66608 49209 1
66608 49210 7
66608 49211 6
66608 49212 1
66608 49213 2
66608 49214 7
66608 49215 5
66608 49216 5
66608 49217 3
66608 49218 1
66608 49220 10
66608 49221 10
66608 49223 10
66608 49225 20
66608 49226 20
66608 49227 10
66608 49228 1
66615 56331 190
66615 56336 10
66615 56345 20
66615 56346 210
66615 56359 10
66615 56361 50
66615 56368 4
66615 56369 120
66615 56371 60
66615 56374 10
66615 56376 10
66615 56377 1
66615 56378 7
66615 56379 5
66615 56381 1
66615 56382 9
66615 56383 1
66615 56384 5
66615 56385 2
66617 58409 10
66617 58416 1
66617 58423 1
66617 58426 1
66617 58427 2
66617 58429 1
66617 58430 2
66617 58431 2
66617 58432 1
66617 58433 1
66617 58435 30
66618 59403 40
66618 59419 60
66618 59440 7
66618 59447 7
66618 59449 1
66618 59451 15
66618 59452 4
66618 59453 6
66618 59454 17
66618 59455 4
66618 59456 10
66618 59457 5
66618 59458 3
66618 59462 10
66618 59468 1
66619 60464 6
66619 60471 5
66619 60473 2
66619 60474 15
66619 60476 2
66619 60477 5
66619 60478 13
66619 60479 5
66619 60480 9
66619 60481 5
66619 60482 1
66620 61488 1
66620 61498 4
66620 61499 2
66620 61501 2
66620 61502 3
66620 61503 2
66620 61504 2
66620 61505 2
66620 61506 1
66621 62512 2
66621 62519 1
66621 62521 1
66621 62522 6
66621 62523 5
66621 62524 2
66621 62526 6
66621 62527 3
66621 62528 6
66621 62529 5
66621 62530 1
66622 63529 10
66622 63536 7
66622 63543 9
66622 63545 2
66622 63546 17
66622 63547 13
66622 63548 3
66622 63549 6
66622 63551 6
66622 63552 12
66622 63553 5
66622 63554 2
66622 63564 1
66623 64560 5
66623 64567 1
66623 64569 2
66623 64570 4
66623 64571 5
66623 64572 2
66623 64573 3
66623 64574 6
66623 64576 4
66623 64577 5
66623 64578 1
66623 64588 1
66624 65547 10
66624 65584 5
66624 65591 5
66624 65593 1
66624 65594 10
66624 65595 9
66624 65596 2
66624 65597 6
66624 65598 12
66624 65599 4
66624 65601 7
66624 65602 3
66624 65612 1
66626 67632 1
66626 67642 3
66626 67643 1
66626 67644 1
66626 67645 1
66626 67646 2
66626 67647 1
66626 67648 3
66626 67649 2
66626 67660 1
66636 77872 1
66636 77882 1
66636 77886 1
66636 77887 1
66636 77888 1
66636 77889 1
66636 77890 1
67632 49163 10
67632 49177 10
67632 49179 10
67632 49199 20
67632 49207 40
67632 49209 10
67632 49210 7
67632 49211 6
67632 49212 1
67632 49213 2
67632 49214 7
67632 49215 5
67632 49216 5
67632 49217 3
67632 49218 1
67632 49220 10
67632 49221 10
67632 49223 10
67632 49225 20
67632 49226 20
67632 49227 10
67632 49228 1
67642 59403 40
67642 59419 60
67642 59440 7
67642 59447 70
67642 59449 10
67642 59451 15
67642 59452 4
67642 59453 6
67642 59454 17
67642 59455 4
67642 59456 10
67642 59457 5
67642 59458 3
67642 59462 10
67642 59468 1
67643 60464 6
67643 60471 50
67643 60473 20
67643 60474 15
67643 60476 2
67643 60477 5
67643 60478 13
67643 60479 5
67643 60480 9
67643 60481 5
67643 60482 1
67644 61488 1
67644 61498 4
67644 61499 2
67644 61501 2
67644 61502 3
67644 61503 2
67644 61504 2
67644 61505 2
67644 61506 1
67645 62512 2
67645 62519 10
67645 62521 10
67645 62522 6
67645 62523 5
67645 62524 2
67645 62526 6
67645 62527 3
67645 62528 6
67645 62529 5
67645 62530 1
67646 63529 10
67646 63536 7
67646 63543 90
67646 63545 20
67646 63546 17
67646 63547 13
67646 63548 3
67646 63549 6
67646 63551 6
67646 63552 12
67646 63553 5
67646 63554 2
67646 63564 1
67647 64560 5
67647 64567 10
67647 64569 20
67647 64570 4
67647 64571 5
67647 64572 2
67647 64573 3
67647 64574 6
67647 64576 4
67647 64577 5
67647 64578 1
67647 64588 1
67648 65547 10
67648 65584 5
67648 65591 50
67648 65593 10
67648 65594 10
67648 65595 9
67648 65596 2
67648 65597 6
67648 65598 12
67648 65599 4
67648 65601 7
67648 65602 3
67648 65612 1
67649 66608 3
67649 66615 20
67649 66617 10
67649 66618 5
67649 66619 5
67649 66620 2
67649 66621 5
67649 66622 5
67649 66623 5
67649 66624 7
67649 66626 2
67649 66636 1
67660 77872 1
67660 77882 1
67660 77886 1
67660 77887 1
67660 77888 1
67660 77889 1
67660 77890 1
68665 58409 10
68665 58416 10
68665 58423 10
68665 58426 10
68665 58427 20
68665 58429 10
68665 58430 20
68665 58431 20
68665 58432 10
68665 58433 10
68665 58435 3
69643 11264 50
69643 11266 30
69643 11267 30
69643 11274 10
69643 11276 10
69643 11277 10
69643 11278 10
69643 11279 10
69643 11287 90
69643 11288 7
69643 11289 12
69643 11290 310
69643 11291 17
69643 11292 80
69643 11293 20
69643 11295 30
69643 11296 10
69643 11297 20
69643 11298 30
69643 11299 30
69643 11300 20
69643 11301 20
69643 11302 20
69643 11307 30
69643 11308 10
69643 11312 1
69643 11313 20
69643 11315 20
69643 11319 190
69643 11322 40
69643 11328 10
69643 11332 1
69643 11333 1
69643 11334 1
69643 11335 1
69643 11336 10
69656 24587 7
69656 24599 20
69656 24601 13
69656 24602 40
69656 24603 1
69656 24617 2
69656 24618 10
69656 24626 10
69656 24644 1
69656 24645 1
69656 24646 1
69657 25611 12
69657 25623 10
69657 25624 13
69657 25626 10
69657 25627 5
69657 25639 10
69657 25640 10
69657 25641 3
69657 25642 20
69657 25648 1
69657 25655 20
69657 25668 5
69657 25669 6
69657 25670 4
69657 25671 1
69657 25675 3
69659 27659 17
69659 27671 50
69659 27672 1
69659 27673 5
69659 27674 10
69659 27676 10
69659 27677 10
69659 27679 10
69659 27681 10
69659 27691 10
69659 27696 1
69659 27706 60
69659 27716 1
69659 27717 2
69659 27718 1
69659 27719 1
69659 27720 10
69673 42008 2
69673 42009 3
69673 42026 20
69673 42039 50
69673 42041 10
69673 42046 10
69673 42052 1
69673 42053 1
69673 42054 1
69673 42055 1
69673 42059 1
69680 49163 1
69680 49177 1
69680 49179 1
69680 49199 20
69680 49207 40
69680 49209 10
69680 49210 70
69680 49211 60
69680 49212 10
69680 49213 20
69680 49214 70
69680 49215 50
69680 49216 50
69680 49217 30
69680 49218 10
69680 49220 1
69680 49221 1
69680 49223 1
69680 49225 20
69680 49226 20
69680 49227 1
69680 49228 10
69701 70667 1
69701 70680 1
69701 70681 6
69701 70683 2
69701 70697 1
69701 70704 1
69701 70724 6
69701 70726 4
69701 70727 2
69701 70731 3
69702 71691 1
69702 71704 1
69702 71705 4
69702 71707 1
69702 71721 1
69702 71738 10
69702 71748 4
69702 71749 4
69702 71751 2
69702 71755 1
69703 72715 1
69703 72729 1
69703 72731 1
69703 72745 1
69703 72752 1
69703 72772 2
69703 72773 2
69703 72774 2
69703 72779 1
69707 76825 3
69707 76841 1
69707 76848 1
69707 76868 3
69707 76869 3
69707 76870 1
69707 76871 1
70667 11264 50
70667 11266 30
70667 11267 30
70667 11274 10
70667 11276 10
70667 11277 10
70667 11278 10
70667 11279 10
70667 11287 90
70667 11288 7
70667 11289 12
70667 11290 310
70667 11291 17
70667 11292 80
70667 11293 20
70667 11295 30
70667 11296 10
70667 11297 20
70667 11298 30
70667 11299 30
70667 11300 20
70667 11301 20
70667 11302 20
70667 11307 30
70667 11308 10
70667 11312 1
70667 11313 20
70667 11315 20
70667 11319 190
70667 11322 40
70667 11328 10
70667 11332 1
70667 11333 1
70667 11334 1
70667 11335 1
70667 11336 10
70680 24587 7
70680 24599 20
70680 24601 13
70680 24602 40
70680 24603 1
70680 24617 2
70680 24618 10
70680 24626 10
70680 24644 1
70680 24645 1
70680 24646 1
70681 25611 12
70681 25623 10
70681 25624 13
70681 25626 10
70681 25627 5
70681 25639 10
70681 25640 10
70681 25641 3
70681 25642 20
70681 25648 1
70681 25655 20
70681 25668 5
70681 25669 6
70681 25670 4
70681 25671 1
70681 25675 3
70683 27659 17
70683 27671 50
70683 27672 1
70683 27673 5
70683 27674 10
70683 27676 10
70683 27677 10
70683 27679 10
70683 27681 10
70683 27691 10
70683 27696 1
70683 27706 60
70683 27716 1
70683 27717 2
70683 27718 1
70683 27719 1
70683 27720 10
70697 42008 2
70697 42009 3
70697 42026 20
70697 42039 50
70697 42041 10
70697 42046 10
70697 42052 1
70697 42053 1
70697 42054 1
70697 42055 1
70697 42059 1
70704 49163 1
70704 49177 1
70704 49179 1
70704 49199 20
70704 49207 40
70704 49209 10
70704 49210 70
70704 49211 60
70704 49212 10
70704 49213 20
70704 49214 70
70704 49215 50
70704 49216 50
70704 49217 30
70704 49218 10
70704 49220 1
70704 49221 1
70704 49223 1
70704 49225 20
70704 49226 20
70704 49227 1
70704 49228 10
70724 69643 1
70724 69656 1
70724 69657 5
70724 69659 1
70724 69673 1
70724 69680 1
70724 69701 6
70724 69702 4
70724 69703 2
70724 69707 3
70726 71691 1
70726 71704 1
70726 71705 4
70726 71707 1
70726 71721 1
70726 71738 10
70726 71748 4
70726 71749 4
70726 71751 2
70726 71755 1
70727 72715 1
70727 72729 1
70727 72731 1
70727 72745 1
70727 72752 1
70727 72772 2
70727 72773 2
70727 72774 2
70727 72779 1
70731 76825 3
70731 76841 1
70731 76848 1
70731 76868 3
70731 76869 3
70731 76870 1
70731 76871 1
71691 11264 50
71691 11266 30
71691 11267 30
71691 11274 10
71691 11276 10
71691 11277 10
71691 11278 10
71691 11279 10
71691 11287 90
71691 11288 7
71691 11289 12
71691 11290 310
71691 11291 17
71691 11292 80
71691 11293 20
71691 11295 30
71691 11296 10
71691 11297 20
71691 11298 30
71691 11299 30
71691 11300 20
71691 11301 20
71691 11302 20
71691 11307 30
71691 11308 10
71691 11312 10
71691 11313 20
71691 11315 20
71691 11319 190
71691 11322 4
71691 11328 10
71691 11332 1
71691 11333 1
71691 11334 1
71691 11335 1
71691 11336 10
71704 24587 7
71704 24599 20
71704 24601 13
71704 24602 40
71704 24603 1
71704 24617 2
71704 24618 10
71704 24626 10
71704 24644 1
71704 24645 1
71704 24646 1
71705 25611 12
71705 25623 10
71705 25624 13
71705 25626 10
71705 25627 5
71705 25639 10
71705 25640 10
71705 25641 3
71705 25642 20
71705 25648 10
71705 25655 20
71705 25668 5
71705 25669 6
71705 25670 4
71705 25671 1
71705 25675 3
71707 27659 17
71707 27671 50
71707 27672 1
71707 27673 5
71707 27674 10
71707 27676 10
71707 27677 10
71707 27679 10
71707 27681 10
71707 27691 10
71707 27696 10
71707 27706 6
71707 27716 1
71707 27717 2
71707 27718 1
71707 27719 1
71707 27720 10
71721 42008 2
71721 42009 3
71721 42026 20
71721 42039 50
71721 42041 10
71721 42046 10
71721 42052 1
71721 42053 1
71721 42054 1
71721 42055 1
71721 42059 1
71738 59403 4
71738 59419 6
71738 59440 70
71738 59447 70
71738 59449 10
71738 59451 150
71738 59452 40
71738 59453 60
71738 59454 170
71738 59455 40
71738 59456 100
71738 59457 50
71738 59458 30
71738 59462 1
71738 59468 10
71748 69643 1
71748 69656 1
71748 69657 5
71748 69659 1
71748 69673 1
71748 69680 10
71748 69701 6
71748 69702 4
71748 69703 2
71748 69707 3
71749 70667 1
71749 70680 1
71749 70681 6
71749 70683 2
71749 70697 1
71749 70704 10
71749 70724 6
71749 70726 4
71749 70727 2
71749 70731 3
71751 72715 1
71751 72729 1
71751 72731 1
71751 72745 1
71751 72752 10
71751 72772 2
71751 72773 2
71751 72774 2
71751 72779 1
71755 76825 3
71755 76841 1
71755 76848 10
71755 76868 3
71755 76869 3
71755 76870 1
71755 76871 1
72715 11264 50
72715 11266 30
72715 11267 30
72715 11274 10
72715 11276 10
72715 11277 10
72715 11278 10
72715 11279 10
72715 11287 90
72715 11288 70
72715 11289 12
72715 11290 310
72715 11291 17
72715 11292 80
72715 11293 20
72715 11295 30
72715 11296 10
72715 11297 20
72715 11298 30
72715 11299 30
72715 11300 20
72715 11301 20
72715 11302 20
72715 11307 30
72715 11308 10
72715 11312 1
72715 11313 20
72715 11315 20
72715 11319 190
72715 11322 40
72715 11328 10
72715 11332 1
72715 11333 1
72715 11334 1
72715 11335 1
72715 11336 10
72729 25611 12
72729 25623 10
72729 25624 130
72729 25626 10
72729 25627 5
72729 25639 10
72729 25640 10
72729 25641 3
72729 25642 20
72729 25648 1
72729 25655 20
72729 25668 5
72729 25669 6
72729 25670 4
72729 25671 1
72729 25675 3
72731 27659 17
72731 27671 50
72731 27672 10
72731 27673 5
72731 27674 10
72731 27676 10
72731 27677 10
72731 27679 10
72731 27681 10
72731 27691 10
72731 27696 1
72731 27706 60
72731 27716 1
72731 27717 2
72731 27718 1
72731 27719 1
72731 27720 10
72745 42008 20
72745 42009 3
72745 42026 20
72745 42039 50
72745 42041 10
72745 42046 10
72745 42052 1
72745 42053 1
72745 42054 1
72745 42055 1
72745 42059 1
72752 49163 1
72752 49177 1
72752 49179 1
72752 49199 20
72752 49207 40
72752 49209 10
72752 49210 70
72752 49211 60
72752 49212 10
72752 49213 20
72752 49214 70
72752 49215 50
72752 49216 50
72752 49217 30
72752 49218 10
72752 49220 1
72752 49221 1
72752 49223 1
72752 49225 20
72752 49226 20
72752 49227 1
72752 49228 10
72772 69643 1
72772 69656 10
72772 69657 5
72772 69659 1
72772 69673 1
72772 69680 1
72772 69701 6
72772 69702 4
72772 69703 2
72772 69707 3
72773 70667 1
72773 70680 10
72773 70681 6
72773 70683 2
72773 70697 1
72773 70704 1
72773 70724 6
72773 70726 4
72773 70727 2
72773 70731 3
72774 71691 1
72774 71704 10
72774 71705 4
72774 71707 1
72774 71721 1
72774 71738 10
72774 71748 4
72774 71749 4
72774 71751 2
72774 71755 1
72779 76825 3
72779 76841 1
72779 76848 1
72779 76868 3
72779 76869 3
72779 76870 1
72779 76871 1
73739 11264 50
73739 11266 30
73739 11267 30
73739 11274 10
73739 11276 10
73739 11277 10
73739 11278 10
73739 11279 10
73739 11287 90
73739 11288 70
73739 11289 120
73739 11290 31
73739 11291 17
73739 11292 80
73739 11293 20
73739 11295 30
73739 11296 10
73739 11297 20
73739 11298 30
73739 11299 30
73739 11300 20
73739 11301 20
73739 11302 20
73739 11307 30
73739 11308 10
73739 11312 10
73739 11313 20
73739 11315 20
73739 11319 190
73739 11322 40
73739 11328 10
73739 11332 10
73739 11333 10
73739 11334 10
73739 11335 10
73739 11336 1
73754 26635 31
73754 26640 10
73754 26648 40
73754 26649 10
73754 26651 1
73754 26667 10
73754 26673 30
73754 26675 20
73754 26678 10
73754 26679 210
73754 26696 2
73755 27659 17
73755 27671 50
73755 27672 10
73755 27673 50
73755 27674 1
73755 27676 10
73755 27677 10
73755 27679 10
73755 27681 10
73755 27691 10
73755 27696 10
73755 27706 60
73755 27716 10
73755 27717 20
73755 27718 10
73755 27719 10
73755 27720 1
74800 49163 10
74800 49177 10
74800 49179 10
74800 49199 20
74800 49207 40
74800 49209 10
74800 49210 70
74800 49211 60
74800 49212 10
74800 49213 20
74800 49214 70
74800 49215 50
74800 49216 50
74800 49217 30
74800 49218 10
74800 49220 10
74800 49221 10
74800 49223 10
74800 49225 2
74800 49226 2
74800 49227 10
74800 49228 10
74826 75824 2
74826 75849 3
75824 49163 10
75824 49177 10
75824 49179 10
75824 49199 20
75824 49207 40
75824 49209 10
75824 49210 70
75824 49211 60
75824 49212 10
75824 49213 20
75824 49214 70
75824 49215 50
75824 49216 50
75824 49217 30
75824 49218 10
75824 49220 10
75824 49221 10
75824 49223 10
75824 49225 2
75824 49226 2
75824 49227 10
75824 49228 10
75849 74800 2
75849 74826 3
76825 25611 120
76825 25623 10
76825 25624 130
76825 25626 10
76825 25627 50
76825 25639 10
76825 25640 10
76825 25641 3
76825 25642 20
76825 25648 1
76825 25655 20
76825 25668 5
76825 25669 6
76825 25670 4
76825 25671 1
76825 25675 3
76841 42008 20
76841 42009 3
76841 42026 20
76841 42039 50
76841 42041 10
76841 42046 10
76841 42052 1
76841 42053 1
76841 42054 1
76841 42055 1
76841 42059 1
76848 49163 10
76848 49177 1
76848 49179 10
76848 49199 20
76848 49207 40
76848 49209 10
76848 49210 70
76848 49211 60
76848 49212 10
76848 49213 20
76848 49214 70
76848 49215 50
76848 49216 50
76848 49217 30
76848 49218 10
76848 49220 1
76848 49221 1
76848 49223 1
76848 49225 20
76848 49226 20
76848 49227 1
76848 49228 10
76868 69643 10
76868 69656 10
76868 69657 5
76868 69659 10
76868 69673 1
76868 69680 1
76868 69701 6
76868 69702 4
76868 69703 2
76868 69707 3
76869 70667 10
76869 70680 10
76869 70681 6
76869 70683 20
76869 70697 1
76869 70704 1
76869 70724 6
76869 70726 4
76869 70727 2
76869 70731 3
76870 71691 10
76870 71704 10
76870 71705 4
76870 71707 10
76870 71721 1
76870 71738 10
76870 71748 4
76870 71749 4
76870 71751 2
76870 71755 1
76871 72715 10
76871 72729 1
76871 72731 10
76871 72745 1
76871 72752 1
76871 72772 2
76871 72773 2
76871 72774 2
76871 72779 1
77872 49163 10
77872 49177 10
77872 49179 10
77872 49199 20
77872 49207 40
77872 49209 10
77872 49210 7
77872 49211 60
77872 49212 10
77872 49213 20
77872 49214 7
77872 49215 5
77872 49216 5
77872 49217 3
77872 49218 1
77872 49220 10
77872 49221 10
77872 49223 10
77872 49225 20
77872 49226 20
77872 49227 10
77872 49228 1
77882 59403 40
77882 59419 60
77882 59440 7
77882 59447 70
77882 59449 10
77882 59451 150
77882 59452 40
77882 59453 60
77882 59454 17
77882 59455 4
77882 59456 10
77882 59457 5
77882 59458 3
77882 59462 10
77882 59468 1
77886 63529 10
77886 63536 7
77886 63543 90
77886 63545 20
77886 63546 17
77886 63547 130
77886 63548 30
77886 63549 60
77886 63551 6
77886 63552 12
77886 63553 5
77886 63554 2
77886 63564 1
77887 64560 5
77887 64567 10
77887 64569 20
77887 64570 4
77887 64571 50
77887 64572 20
77887 64573 30
77887 64574 6
77887 64576 4
77887 64577 5
77887 64578 1
77887 64588 1
77888 65547 10
77888 65584 5
77888 65591 50
77888 65593 10
77888 65594 10
77888 65595 90
77888 65596 20
77888 65597 60
77888 65598 12
77888 65599 4
77888 65601 7
77888 65602 3
77888 65612 1
77889 66608 3
77889 66615 20
77889 66617 10
77889 66618 5
77889 66619 50
77889 66620 20
77889 66621 50
77889 66622 5
77889 66623 5
77889 66624 7
77889 66626 2
77889 66636 1
77890 67632 1
77890 67642 3
77890 67643 10
77890 67644 10
77890 67645 10
77890 67646 2
77890 67647 1
77890 67648 3
77890 67649 2
77890 67660 1`;

const clu = `# v2.2.0
# ./Infomap  --silent --two-level --directed --num-trials 100
# started at 2022-03-30 13:14:38
# completed in 0.618242 s
# partitioned into 2 levels with 10 top modules
# codelength 4.73066 bits
# relative codelength savings 15.5793%
# flow model directed
# higher order
# state level
# module level 1
# state_id module flow node_id
56382 1 0.00862014 62
27706 1 0.00607214 58
59454 1 0.00580564 62
59451 1 0.00553131 59
63546 1 0.00532533 58
60474 1 0.00508909 58
56379 1 0.00506678 59
56378 1 0.00469042 58
63547 1 0.0044736 59
60478 1 0.00441054 62
58435 1 0.00421901 67
11322 1 0.0039157 58
63552 1 0.00375906 64
68665 1 0.00359038 57
65598 1 0.00342663 62
56384 1 0.0033503 64
60480 1 0.00305345 64
49214 1 0.00295636 62
65595 1 0.00291049 59
59456 1 0.00278486 64
49211 1 0.00275245 59
63548 1 0.00266898 60
65594 1 0.00255532 58
49210 1 0.00255357 58
56368 1 0.00251048 48
74826 1 0.0023619 74
75849 1 0.0023619 73
71738 1 0.00227555 58
61498 1 0.00227499 58
59452 1 0.00226906 60
49226 1 0.00225271 74
49225 1 0.00225271 73
59453 1 0.00221252 61
63536 1 0.00219278 48
49215 1 0.00211168 63
63549 1 0.00206474 61
60464 1 0.00203564 48
56385 1 0.00202671 65
65601 1 0.00199887 65
66624 1 0.00196441 64
49216 1 0.00195553 64
65597 1 0.00194033 61
62528 1 0.00192057 64
62522 1 0.00192057 58
62526 1 0.00192057 62
63551 1 0.00187953 63
63554 1 0.00171758 66
59457 1 0.00170754 65
61502 1 0.00170624 62
64571 1 0.00170543 59
60476 1 0.00170398 60
64574 1 0.00169759 62
60477 1 0.00169636 61
60479 1 0.00169636 63
60481 1 0.00169636 65
66619 1 0.00166581 59
66621 1 0.00166581 61
65602 1 0.00166113 66
59458 1 0.00162006 66
62523 1 0.00160047 59
62529 1 0.00160047 65
42046 1 0.00159335 62
42041 1 0.00159335 57
75824 1 0.0015746 48
74800 1 0.0015746 48
63553 1 0.00156627 65
48176 1 0.00154704 48
76848 1 0.00148371 48
63564 1 0.0014366 76
67642 1 0.00143231 58
67648 1 0.00143231 64
59440 1 0.00142594 48
64577 1 0.00141466 65
64560 1 0.00141466 48
66618 1 0.00140315 58
66622 1 0.00140315 62
66623 1 0.00140315 63
59455 1 0.00136603 63
65584 1 0.00127766 48
49217 1 0.00126701 65
65596 1 0.00118309 60
66636 1 0.0011582 76
66620 1 0.00115508 60
65599 1 0.00114221 63
64572 1 0.00114064 60
61503 1 0.0011375 63
61505 1 0.0011375 65
61504 1 0.0011375 64
61501 1 0.0011375 61
61499 1 0.0011375 59
64570 1 0.00113173 58
64576 1 0.00113173 64
67660 1 0.00111016 76
65612 1 0.00110779 76
64588 1 0.00108963 76
64569 1 0.00107561 57
11328 1 0.00106779 64
66626 1 0.00105001 66
62524 1 0.00104541 60
64573 1 0.00102326 61
56383 1 0.00101336 63
56381 1 0.00101336 61
58431 1 0.000985445 63
58427 1 0.000985445 59
72752 1 0.000968109 48
62527 1 0.000960284 63
56377 1 0.000957793 57
67646 1 0.000954872 62
67649 1 0.000954872 65
60473 1 0.000938621 57
77886 1 0.000927358 62
77882 1 0.000927358 58
77887 1 0.000927358 63
77888 1 0.000927358 64
77872 1 0.000927358 48
77889 1 0.000927358 65
77890 1 0.000927358 66
49213 1 0.000917482 61
59468 1 0.000911741 76
63545 1 0.000886269 57
69680 1 0.000883419 48
11312 1 0.000877948 48
60482 1 0.000851992 66
66608 1 0.000841888 48
70704 1 0.000838353 48
27696 1 0.000789361 48
58430 1 0.00076349 62
25648 1 0.000744181 48
49228 1 0.000741736 76
67643 1 0.000655097 59
67644 1 0.000655097 60
67645 1 0.000655097 61
62512 1 0.000640189 48
49212 1 0.000608467 60
62521 1 0.000590332 57
66617 1 0.000573023 57
49218 1 0.000572062 66
61488 1 0.000568748 48
61506 1 0.000568748 66
62530 1 0.000522704 66
49209 1 0.000520018 57
64578 1 0.000512165 66
59449 1 0.000500151 57
65593 1 0.00049674 57
58416 1 0.000492722 48
58426 1 0.000492722 58
58429 1 0.000492722 61
58432 1 0.000492722 64
58433 1 0.000492722 65
67632 1 0.000477436 48
67647 1 0.000477436 63
11290 2 0.0222993 26
11319 2 0.0153856 55
26635 2 0.0130576 11
26679 2 0.0117119 55
56346 2 0.0114615 26
11291 2 0.00965646 27
56331 2 0.00877967 11
59419 2 0.00789399 27
28683 2 0.00551619 11
27659 2 0.00501728 11
42039 2 0.00497233 55
25611 2 0.00468487 11
23563 2 0.00455307 11
59403 2 0.00401842 11
63543 2 0.00398821 55
24587 2 0.00367784 11
24602 2 0.0032955 26
59447 2 0.0030599 55
11307 2 0.00293467 43
11 2 0.00288357 11
44043 2 0.00287026 11
23579 2 0.00275816 27
26696 2 0.00273138 72
31755 2 0.00237323 11
60471 2 0.00234655 55
65591 2 0.00233359 55
11297 2 0.00227095 33
25655 2 0.00222536 55
73754 2 0.00213238 26
25627 2 0.0021268 27
16439 2 0.00207137 55
16410 2 0.00207137 26
33803 2 0.00204551 11
49207 2 0.00185504 55
34827 2 0.00179673 11
35851 2 0.00179673 11
2059 2 0.00174367 11
65547 2 0.00172423 11
3083 2 0.00172207 11
29723 2 0.00146997 27
50202 2 0.00144094 26
52235 2 0.00142941 11
70683 2 0.00140334 27
26667 2 0.0013902 43
27681 2 0.00132884 33
27691 2 0.00127824 43
27720 2 0.00127544 72
50187 2 0.00121853 11
11279 2 0.00121383 15
11296 2 0.00121383 32
11277 2 0.00121383 13
11274 2 0.00121383 10
11278 2 0.00121383 14
26651 2 0.00119848 27
36875 2 0.00117682 11
37899 2 0.00117682 11
38923 2 0.00117682 11
28699 2 0.00115494 27
66615 2 0.00114605 55
27674 2 0.00108472 26
73755 2 0.00106619 27
73739 2 0.00106619 11
32779 2 0.00103316 11
15371 2 0.00103316 11
14347 2 0.00103316 11
13323 2 0.00103316 11
10251 2 0.00103316 11
33819 2 0.00102276 27
11336 2 0.000990651 72
55322 2 0.000987933 26
44059 2 0.000956754 27
44058 2 0.000956754 26
49179 2 0.000952625 27
52250 2 0.000891666 26
45067 2 0.000808814 11
12299 2 0.000801581 11
72715 2 0.000796391 11
72731 2 0.000796391 27
31771 2 0.000791078 27
69643 2 0.000781314 11
69659 2 0.000781314 27
25626 2 0.000772833 26
49163 2 0.000762148 11
70667 2 0.00070167 11
29707 2 0.000617951 11
71691 2 0.000605648 11
71707 2 0.000605648 27
62519 2 0.000590332 55
64567 2 0.000537805 55
24603 2 0.000525405 27
58423 2 0.000381745 55
11289 3 0.00821571 25
56361 3 0.00576904 41
11288 3 0.00563491 24
26648 3 0.00514623 24
25624 3 0.00489966 24
24601 3 0.004632 25
27673 3 0.0040099 25
25675 3 0.00378053 75
24617 3 0.00307075 41
25641 3 0.00283523 41
51224 3 0.00274232 24
25642 3 0.00270498 42
42026 3 0.00255182 42
43049 3 0.00239044 41
43033 3 0.00239044 25
70731 3 0.00228451 75
63529 3 0.00226439 41
25669 3 0.00224917 69
42008 3 0.0021449 24
76825 3 0.00211202 25
76868 3 0.00211202 68
76869 3 0.00211202 69
69707 3 0.00195347 75
27717 3 0.00194337 69
25668 3 0.00187431 68
24618 3 0.00174904 42
70724 3 0.00173935 68
70681 3 0.00173935 25
69701 3 0.00172676 69
25640 3 0.00169062 40
25670 3 0.00164173 70
69702 3 0.0015896 70
70726 3 0.00158842 70
59462 3 0.00152369 70
69657 3 0.00143896 25
40985 3 0.00143843 25
71705 3 0.00141022 25
71748 3 0.00141022 68
71749 3 0.00141022 69
42009 3 0.0013788 25
42055 3 0.00131787 71
42059 3 0.00131787 75
23576 3 0.00125405 24
56345 3 0.00125211 25
43032 3 0.00119522 24
58409 3 0.00116112 41
39961 3 0.00113626 25
72774 3 0.00108406 70
72745 3 0.0010811 41
42054 3 0.00107028 70
42053 3 0.00107028 69
42052 3 0.00107028 68
49227 3 0.0010585 75
27719 3 0.0010076 71
11335 3 0.00100696 71
49220 3 0.00100096 68
49221 3 0.00100096 69
49223 3 0.00100096 71
76870 3 0.000977896 70
76841 3 0.000977896 41
27716 3 0.000971685 68
71751 3 0.000964189 71
11333 3 0.000961904 69
11332 3 0.000961904 68
11334 3 0.0009416 70
27672 3 0.000897408 24
69656 3 0.00088332 24
49177 3 0.000882762 25
72779 3 0.000872075 75
24646 3 0.000855459 70
24645 3 0.000855459 69
24644 3 0.000855459 68
71755 3 0.000851484 75
70680 3 0.000820449 24
70697 3 0.000775244 41
27718 3 0.000767324 70
70727 3 0.000766726 71
69703 3 0.000766619 71
71704 3 0.000729736 24
71721 3 0.000721944 41
76871 3 0.000704007 71
72772 3 0.000666015 68
72773 3 0.000666015 69
69673 3 0.000665246 41
26649 3 0.000647592 25
25671 3 0.00063708 71
23577 3 0.000627023 25
72729 3 0.000333008 25
11287 4 0.00850755 23
27671 4 0.0050203 23
23574 4 0.00304978 22
23573 4 0.00304978 21
23572 4 0.00304978 20
26640 4 0.00277236 16
23568 4 0.00228733 16
23569 4 0.00228733 17
23570 4 0.00228733 18
23571 4 0.00228733 19
24599 4 0.00218816 23
21524 4 0.00190085 20
20501 4 0.00189125 21
23564 4 0.00164817 12
12311 4 0.00160316 23
22548 4 0.0015278 20
22549 4 0.0015278 21
22551 4 0.0015278 23
21526 4 0.00152068 22
21527 4 0.00152068 23
20499 4 0.001513 19
20502 4 0.001513 22
20503 4 0.001513 23
16403 4 0.0014782 19
16402 4 0.0014782 18
16401 4 0.0014782 17
18449 4 0.00147461 17
18448 4 0.00147461 16
17427 4 0.00147461 19
17426 4 0.00147461 18
17424 4 0.00147461 16
18451 4 0.00147461 19
29719 4 0.00146997 23
19472 4 0.00146936 16
19473 4 0.00146936 17
19474 4 0.00146936 18
19476 4 0.00146936 20
23583 4 0.00132235 31
30743 4 0.00125735 23
11276 4 0.00117099 12
22544 4 0.00114585 16
22545 4 0.00114585 17
22546 4 0.00114585 18
22547 4 0.00114585 19
21522 4 0.00114051 18
21523 4 0.00114051 19
21520 4 0.00114051 16
21521 4 0.00114051 17
20498 4 0.00113475 18
20497 4 0.00113475 17
20496 4 0.00113475 16
16407 4 0.00110865 23
16406 4 0.00110865 22
16405 4 0.00110865 21
16404 4 0.00110865 20
18455 4 0.00110596 23
18454 4 0.00110596 22
18453 4 0.00110596 21
18452 4 0.00110596 20
17431 4 0.00110596 23
17430 4 0.00110596 22
17429 4 0.00110596 21
17428 4 0.00110596 20
19479 4 0.00110202 23
19478 4 0.00110202 22
19477 4 0.00110202 21
56336 4 0.00109627 16
25623 4 0.000809123 23
31767 4 0.000682368 23
56369 5 0.00715638 49
50231 5 0.00492785 55
50227 5 0.00432282 51
52273 5 0.0040125 49
56371 5 0.00371834 51
50226 5 0.00325618 50
24626 5 0.00272644 50
52276 5 0.00267806 52
52279 5 0.002675 55
52277 5 0.00266586 53
26678 5 0.00264964 54
51249 5 0.0023739 49
54323 5 0.00226739 51
53287 5 0.00225416 39
39988 5 0.00219036 52
55347 5 0.00197587 51
26673 5 0.00196008 49
53299 5 0.00191498 51
11313 5 0.0019083 49
11315 5 0.0019083 51
50232 5 0.00181046 56
25639 5 0.00165906 39
52278 5 0.00141189 54
26675 5 0.00130672 51
57393 5 0.00128859 49
57399 5 0.00128859 55
56359 5 0.00126263 39
56376 5 0.0012149 56
39991 5 0.00113626 55
55345 5 0.000987933 49
55351 5 0.000987933 55
56374 5 0.000963018 54
50230 5 0.000753679 54
11264 6 0.00580353 0
3 6 0.00576715 3
3072 6 0.00574022 0
2048 6 0.00464979 0
2 6 0.00461372 2
2051 6 0.00348735 3
11266 6 0.00348212 2
11267 6 0.00348212 3
8 6 0.00345554 8
3074 6 0.00344413 2
8192 6 0.00294003 0
5 6 0.0017666 5
6 6 0.0017666 6
7 6 0.0017666 7
9 6 0.0017666 9
1 6 0.0017666 1
4 6 0.0017666 4
1024 6 0.00150301 0
4096 6 0.00150301 0
5120 6 0.00150301 0
6144 6 0.00150301 0
7168 6 0.00150301 0
9216 6 0.00150301 0
11298 7 0.00334234 34
11299 7 0.00334234 35
11300 7 0.00222822 36
11301 7 0.00222822 37
11302 7 0.00222822 38
11293 7 0.00199617 29
35874 7 0.00179673 34
34851 7 0.00179673 35
35878 7 0.00119782 38
35877 7 0.00119782 37
35876 7 0.00119782 36
35869 7 0.00119782 29
34854 7 0.00119782 38
34853 7 0.00119782 37
34845 7 0.00119782 29
34852 7 0.00119782 36
27677 7 0.00119331 29
36898 7 0.00117682 34
36899 7 0.00117682 35
36901 7 0.00117682 37
36902 7 0.00117682 38
37922 7 0.00117682 34
37923 7 0.00117682 35
37924 7 0.00117682 36
37926 7 0.00117682 38
38946 7 0.00117682 34
38947 7 0.00117682 35
38948 7 0.00117682 36
38949 7 0.00117682 37
29731 7 0.00105566 35
29730 7 0.00105566 34
23581 7 0.000678465 29
36893 7 0.00058841 29
37917 7 0.00058841 29
38941 7 0.00058841 29
29733 7 0.000527832 37
29732 7 0.000527832 36
29734 7 0.000527832 38
11292 8 0.00878739 28
28717 8 0.00621734 45
46108 8 0.00528756 28
28716 8 0.00262223 44
45084 8 0.00242644 28
27676 8 0.00132555 28
11308 8 0.0011707 44
31774 9 0.00336954 30
11295 9 0.0032672 31
30751 9 0.00251471 31
27679 9 0.00121305 31
23582 9 0.00105824 30
49199 10 0.00232634 47
48174 10 0.00172265 46
47151 10 0.00146566 47
`;

const lesMiserables = { net, clu };

export default lesMiserables;
